// apiConfig.js
const API_BASE_URL = process.env.apiHost;
// New appcom base URL (/appcom/); see APPCOM_BASE_URL in vite.config.mjs.
const APPCOM_BASE_URL = process.env.APPCOM_BASE_URL;
const preEnvUrl = API_BASE_URL.replace('insightappcom', 'insightmhs');
// Stay on the api-web host: the `-api` host is device-facing and its certificate is not trusted by browsers.
const DEVCOM_BASE_URL = API_BASE_URL ? API_BASE_URL.replace('insightappcom', 'insightdevcom') : '';

// AIDN + Hindsight live in the standalone aidn-agent service on its own per-env host
// (process.env.aidnHost). When it is unset, the path stays relative so axiosInstance routes it
// through apiHost to the monolith's still-embedded /aidn/v1 — the same fallback aidnService.js uses.
const AIDN_BASE_URL = process.env.aidnHost ? process.env.aidnHost.replace(/\/+$/, '') : '';

// Special base URL for Global Search API
const GLOBAL_SEARCH_API_BASE_URL = process.env.apiHost ? process.env.apiHost.replace('insightappcom', 'insightglobalsearch') : '';

export const API_ENDPOINTS = {
  COUNTRY_LIST: {
    method: 'get',
    url: `${API_BASE_URL}public/v1/countryList`
  },
  GET_MSP_ORG_DETAILS: {
    method: 'put',
    url: `${API_BASE_URL}organization/v1/orgDetails/{_Id}/{page}{searchText}`
  },
  GET_MSP_ORG_DETAIL: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/{_Id}/{orgId}`
  },
  GET_ALL_USERS_LIST: {
    method: 'put',
    url: `${API_BASE_URL}unified/administration/v1/alluserslist/{_Id}/{orgId}/{page}{searchText}`
  },
  ADD_ORGANIZATION: {
    method: 'post',
    url: `${API_BASE_URL}organization/v1/{_Id}/{orgId}`
  },
  INVITE_USER: {
    method: 'post',
    url: `${API_BASE_URL}unified/administration/v1/inviteUser/{_Id}?role={role}`
  },
  UPDATE_USER: {
    method: 'put',
    url: `${API_BASE_URL}unified/administration/v1/updateUser/{_Id}/{targetUserId}?role={role}`
  },
  RESEND_INVITATION: {
    method: 'post',
    url: `${API_BASE_URL}user/v1/resend/{_Id}`
  },
  DELETE_USER: {
    method: 'delete',
    url: `${API_BASE_URL}unified/administration/v1/user/{_Id}/{targetUserId}?role={role}`
  },
  DELETE_MULTIPLE_USERS: {
    method: 'delete',
    url: `${API_BASE_URL}unified/administration/v1/deleteMultipleUsers/{_Id}`
  },
  GET_ORG_CHILD_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/orgLocationsTree/{_Id}`
  },
  NEW_DEVICES: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/topEntitiesByDeviceCount/msp/{_Id}/true/0`
  },
  DEVICES: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/topEntitiesByDeviceCount/msp/{_Id}/false/0`
  },
  CRITICAL_ALARMS: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/topEntitiesByAlarms/msp/{_Id}/0`
  },
  TRAFFIC: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/topEntitiesByTraffic/msp/{_Id}/0/{deviceFilter}`
  },
  CLIENTS: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/topEntitiesByClients/msp/{_Id}/0`
  },
  GENERAL_SUMMARY: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/generalSummary/{_Id}/{scopeId}/{organization_Id}`
  },
  GET_CLOUD_VERSION: {
    method: 'get',
    url: `${API_BASE_URL}public/v2/info/{_Id}`
  },
  DEVICE_SUMMARY: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/deviceSummary/{_Id}/{scopeId}/{organization_Id}`
  },
  TRAFFIC_BAR_CHART: {
    method: 'get',
    url: `${API_BASE_URL}wireless/v1/trafficBarChart/{time}/{_Id}/{scopeId}/{organization_Id}`
  },
  WIFI_DISTRIBUTION: {
    method: 'get',
    url: `${API_BASE_URL}wireless/v1/wifiDistribution/{time}/{_Id}/{scopeId}/{organization_Id}`
  },
  LINE_CHART_TOP_SSID_BY_TRAFFIC: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/topSSIDByTraffic/{_Id}/{scopeId}/{organization_Id}/{time}`
  },
  LINE_CHART_CLIENT_TREND_CHART: {
    method: 'get',
    url: `${API_BASE_URL}wireless/v1/clientTrendChart/{time}/{_Id}/{scopeId}/{organization_Id}`
  },
  AP_CLIENT_TREND_CHART: {
    method: 'get',
    url: `${API_BASE_URL}wireless/v1/apClientTrendChart/{time}/{_Id}/{networkId}/{serialNo}`
  },
  LINE_CHART_TOP_ROUTER_BY_TRAFFIC: {
    method: 'get',
    url: `${API_BASE_URL}wired/v1/topRouterTrafficLine/{_Id}/{scopeId}/{organization_Id}/{time}`
  },
  TOP_SWITCHES_BY_UPLINK_UTILIZATION: {
    method: 'get',
    url: `${API_BASE_URL}wired/v1/topSwUplinkUtilization/{_Id}/{scopeId}/{organization_Id}/{time}`
  },
  TOP_SWITCHES_BY_POE_UTILIZATION: {
    method: 'get',
    url: `${API_BASE_URL}wired/v1/topSwPoEUtilization/{_Id}/{scopeId}/{organization_Id}/{time}`
  },
  TOP_SWITCHES_BY_PORT_ERROR: {
    method: 'get',
    url: `${API_BASE_URL}wired/v1/topSwPortError/{_Id}/{scopeId}/{organization_Id}/{time}`
  },
  TOP_ROUTER_BY_WAN_PORT_ERROR: {
    method: 'get',
    url: `${API_BASE_URL}wired/v1/topRouterWanPortError/{_Id}/{scopeId}/{organization_Id}/{time}`
  },
  GET_USER_PREFERENCE: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/userpref/{_Id}/{tableView}`
  },
  SAVE_USER_PREFERENCE: {
    method: 'post',
    url: `${API_BASE_URL}unified/v1/userpref/{_Id}/{tableView}`
  },
  DELETE_ORGANIZATION: {
    method: 'delete',
    url: `${API_BASE_URL}unified/v1/deleteOrganizations/{_Id}`
  },
  TIME_ZONE_LIST: {
    method: 'get',
    url: `${API_BASE_URL}public/v1/timeZoneList`
  },
  GET_COUNTRY_LIST: {
    method: 'get',
    url: `${API_BASE_URL}public/v1/countryList`
  },
  GET_MSP_LOC_DETAILS: {
    method: 'put',
    url: `${API_BASE_URL}unified/v1/locationGridDetails/{_Id}/{page}{searchText}`
  },
  GET_ORG_LOC_DETAILS: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/locationGridDetails/{_Id}/{orgId}/{page}{searchText}`
  },
  GET_ALL_ORG_LIST: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/orgInfo/{_Id}`
  },
  GET_ALLOCATION_MODE: {
    method: 'get',
    url: `${API_BASE_URL}user/v2/allocationMode/{_Id}`
  },
  SAVE_ALLOCATION_MODE: {
    method: 'post',
    url: `${API_BASE_URL}user/v2/allocationMode/{_Id}`
  },
  DELETE_NETWORKS: {
    method: 'delete',
    url: `${API_BASE_URL}unified/v1/deleteNetworks/{_Id}`
  },
  ADD_LOCATION: {
    method: 'post',
    url: `${API_BASE_URL}network/v3/{_Id}/{orgId}`
  },
  GET_ORG_MAP_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/map/org/{_Id}/{orgId}`
  },
  LOCATION_TOP_ENTITIES_BY_DEVICES: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/topEntitiesByDeviceCount/organization/{_Id}/false/1/{organization_Id}`
  },
  LOCATION_TOP_ENTITIES_BY_ALARMS: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/topEntitiesByAlarms/organization/{_Id}/1/{organization_Id}`
  },
  LOCATION_TOP_ENTITIES_BY_CLIENTS: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/topEntitiesByClients/organization/{_Id}/1/{organization_Id}`
  },
  LOCATION_TOP_ENTITIES_BY_TRAFFIC: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/topEntitiesByTraffic/organization/{_Id}/1/{organization_Id}/{deviceFilter}`
  },

  //LED Settings Endpoints
  LOCATION_SETTINGS_GET_NETWORK_LED_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/getLedSettings/{networkId}/{_Id}`
  },
  LOCATION_SETTINGS_SET_LED_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/setLedSettings/{networkId}/{_Id}`
  },
  // Device-level LED Settings Endpoints
  GET_AP_LED_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/getLedSettings/AP/{serialNo}/{_Id}`
  },
  SET_AP_LED_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/setLedSettings/AP/{deviceId}/{_Id}`
  },
  // PR (Pro Router) device-level LED Settings
  // GET: v1 keyed by serialNo (same as legacy webportal / AP); SET: v2 keyed by deviceId
  GET_PR_LED_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/getLedSettings/PR/{serialNo}/{_Id}`
  },
  SET_PR_LED_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/setLedSettings/PR/{deviceId}/{_Id}`
  },
  // Device-level Antenna Switch Endpoints (WBE700Y/WBE708Y only)
  GET_AP_ANTENNA_SWITCH: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/getAntennaSwitch/AP/{serialNo}/{_Id}`
  },
  SET_AP_ANTENNA_SWITCH: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/config/{serialNo}/AP/antennaSwitch/{_Id}`
  },
  ADD_SINGLE_DEVICE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/getDeviceType/{_Id}`
  },
  GET_DEVICE_IMAGE: {
    method: 'get',
    url: `${API_BASE_URL}public/v1/models/`
  },
  ADD_DEVICE_ROLE: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/{_Id}/{Organization_Id}/{networkId}`
  },
  GET_ACCOUNT_DETAILS: {
    method: 'put',
    url: `${API_BASE_URL}organization/v1/deviceInfo/{_Id}/all/{page}{searchText}`
  },
  MANAGE_DEVICE: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/manage/{deviceID}/{_Id}/{manageStatus}`
  },
  GET_SINGLE_LOCATION: {
    method: 'get',
    url: `${API_BASE_URL}network/v2/config/{locId}/{_Id}`
  },
  setNetworkLocation: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/config/{locId}/location/{_Id}`
  },
  setAdminCred: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/config/{locId}/adminCred/{_Id}`
  },
  updateNetworkInfo: {
    method: 'post',
    url: `${API_BASE_URL}network/v2/updateNetwork/{_Id}`
  },
  updateWirelessRegion: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/config/{networkId}/wirelessRegion/{_Id}`
  },
  getAllLocations: {
    method: 'get',
    url: `${API_BASE_URL}network/v3/networks/{userAccountId}/{_Id}`
  },
  GET_POLICY_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/{_Id}/{orgId}`
  },
  UPDATE_POLICY_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}organization/v1/{_Id}/{orgId}`
  },
  ADD_MULTIPLE_LOCATIONS: {
    method: 'post',
    url: `${API_BASE_URL}network/v3/{_Id}/{orgId}`
  },
  GET_MHS_Data: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}profile/v1/{_Id}/{orgId}/{status}`
  },
  // Mobile Profile List with pagination, sorting, filtering and search (v2)
  // searchText is passed as RequestParam (query parameter)
  GET_MHS_PROFILE_LIST_V2: {
    method: 'post',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}profile/v2/profileList/{_Id}/{orgId}/{isRequiredDefault}/{page}{searchText}`
  },
  // Single Mobile Profile detail: same profileList v2 contract (and request body) with the
  // profileId appended as the last path segment. Used by the Firmware Management screen to open
  // a profile from the Upgrade Status column.
  GET_MHS_PROFILE_DETAILS_V2: {
    method: 'post',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}profile/v2/profileList/{_Id}/{orgId}/{isRequiredDefault}/{page}/{profileId}{searchText}`
  },
  GET_MHS_CHANNEL_LIST: {
    method: 'get',
    url: `${preEnvUrl}network/v1/channelList/{_Id}/{orgId}/{code}`
  },
  // Delete Multiple MHS Profiles (v2)
  DELETE_MHS_PROFILES: {
    method: 'delete',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}profile/v2/{_Id}/{orgId}`
  },
  // Clone MHS Profile
  // POST /profile/v1/{userId}/{orgId}/{profileId}
  // Headers: token, accountId, apikey, networkId
  // Body: { profileInfo: { profileName, ssid, password, orgId, networkId } }
  CLONE_MHS_PROFILE: {
    method: 'post',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}profile/v1/{_Id}/{orgId}/{profileId}`
  },
  // Export one MHS Profile as a Mobile Profile JSON file (in details)
  // GET /profile/v1/export/{userId}/{orgId}/{profileId}
  // Headers: token, accountId, apiKey, networkId
  EXPORT_MHS_PROFILE: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}profile/v1/export/{_Id}/{orgId}/{profileId}`
  },
  // Create an MHS Profile from a Mobile Profile JSON file
  // POST /profile/v1/import/{userId}/{orgId}
  // Headers: token, accountId, apiKey, networkId
  // Body: { profileName, profileFile }
  IMPORT_MHS_PROFILE: {
    method: 'post',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}profile/v1/import/{_Id}/{orgId}`
  },
  // Get Organization List for Select (used in clone profile)
  // GET /organization/v1/orgInfo/{userId}
  GET_ORG_LIST_FOR_SELECT: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/orgInfo/{_Id}`
  },
  // Get Location/Network List per Organization (used in clone profile)
  // GET /network/v1/networks/{userId}/{orgId}/true/networkFilter/false
  // Note: page parameter is optional, filterType is 'false' for clone
  GET_LOCATIONS_PER_ORG: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/networks/{_Id}/{orgId}/true/networkFilter/false`
  },
  // MHS Device APIs
  GET_MHS_SUMMARY: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/{_Id}/{orgId}/{deviceId}/MHS/summary`
  },
  GET_MHS_CLIENTS: {
    method: 'get',
    url: `${API_BASE_URL}client/v1/clientfilter/{_Id}/{orgId}/{networkId}`
  },
  GET_MHS_CLIENT_LIST: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}client/v1/{_Id}/{orgId}/{deviceId}/MHS/{isConnected}/{page}{searchText}`
  },
  DELETE_DISCONNECTED_MHS_CLIENTS: {
    method: 'delete',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}client/v1/deletedisconnectedclients/{_Id}/{networkId}/{deviceId}`
  },
  GET_MHS_CLIENT_COUNT: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}client/v1/count/{_Id}/{orgId}/{deviceId}/MHS/1`
  },
  GET_MHS_CELLULAR: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/{_Id}/{orgId}/{deviceId}/MHS/celluler`
  },
  GET_MHS_WIFI_NETWORKS: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/{_Id}/{orgId}/{deviceId}/MHS/wifinetworks`
  },
  PUT_MHS_WIFI_SETTINGS: {
    method: 'put',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/wifisettings/{_Id}/{orgId}/{deviceId}?rebootRequired={rebootRequired}`
  },
  GET_MHS_LCD_SCREEN_LOCK: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/{_Id}/{orgId}/{deviceId}/MHS/lcdLock`
  },
  GET_MHS_LAN_IP: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/{_Id}/{orgId}/{deviceId}/MHS/lanip`
  },
  GET_MHS_TRAFFIC: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/{_Id}/{orgId}/{deviceId}/MHS/traffic`
  },
  GET_MHS_TRAFFIC_V2: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v2/{_Id}/{networkId}/{deviceId}/{time}`
  },
  GET_MHS_PORT_FORWARDING: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/{accountId}/{orgId}/{deviceId}/MHS/portforwarding`
  },
  PUT_MHS_LCD_SCREEN_LOCK: {
    method: 'put',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/updateconfig/{accountId}/{orgId}/{deviceId}/MHS/lcdLock`
  },
  PUT_MHS_PORT_FORWARDING: {
    method: 'put',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/updateconfig/{accountId}/{orgId}/{deviceId}/MHS/portforwarding`
  },
  // Firmware settings currently applied on the device (Settings > Firmware). Same device/v1
  // contract as port forwarding, keyed by the firmwareUpdateSettings section.
  GET_MHS_FIRMWARE_UPDATE_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/{accountId}/{orgId}/{deviceId}/MHS/firmwareUpdateSettings`
  },
  // Tells the device to check for newer firmware and install it if available. Empty payload.
  PUT_MHS_FIRMWARE_CHECK: {
    method: 'put',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/updateconfig/{accountId}/{orgId}/{deviceId}/MHS/firmwareCheck`
  },
  GET_MHS_ACCESS_CONTROL: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/{accountId}/{orgId}/{deviceId}/MHS/accesscontrol`
  },
  PUT_MHS_ACCESS_CONTROL: {
    method: 'put',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/updateconfig/{accountId}/{orgId}/{deviceId}/MHS/accesscontrol`
  },
  GET_MHS_NOTIFICATIONS: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/notification/{accountId}/{orgId}/{deviceId}/MHS`
  },
  GET_MHS_TROUBLESHOOT: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/devicestatus/{accountId}/{networkId}/{deviceId}/{orgId}`
  },
  GET_MHS_FW_COMPATIBILITY: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/fwcompatibilty/{accountId}/14/1/{serialNo}`
  },
  GET_MHS_BACKUP_INFO: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/getbackupinfo/{deviceId}/{accountId}`
  },
  PUT_MHS_OWNER_PASSWORD: {
    method: 'put',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/updateconfig/{_Id}/{orgId}/{deviceId}/MHS/{ownerPassword}`
  },
  // Get devices assigned to MHS Profile (v1 - client-side)
  GET_MHS_PROFILE_DEVICE_LIST: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/{_Id}/{orgId}/MHS/profile`
  },
  // Get devices assigned to MHS Profile (v2 - server-side pagination, sorting, filtering)
  // Headers: accountId, token, apiKey, networkId, profileId
  // RequestParam: searchText
  // RequestBody: { sortBy, sortDir, dataFilter }
  GET_MHS_PROFILE_DEVICE_LIST_V2: {
    method: 'post',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v2/{_Id}/{orgId}/{page}{searchText}`
  },
  // MHS device list at location (classic: getMobileDeviceList → device/v1/.../MHS/all)
  GET_MHS_DEVICE_LIST: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/{_Id}/{orgId}/MHS/{scope}`
  },
  // Location geofence configuration for MHS (insightmhs network service)
  GET_MHS_GEOFENCE: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}network/v1/geofence/{_Id}/{orgId}`
  },
  PUT_MHS_GEOFENCE: {
    method: 'put',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}network/v1/geofence/{_Id}/{orgId}`
  },
  /** POST geofence v1 — path insightmhs/geofence/v1/{userId}/{orgId}/{networkId}. Body e.g. `{ geofence: { isGeoEnabled: "1" } }` */
  POST_MHS_ENABLE_GEOFENCE: {
    method: 'post',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}geofence/v1/{_Id}/{orgId}/{networkId}`
  },
  /** GET geofence list — path geofence/v1/list/{orgId}/{networkId} */
  GET_GEOFENCE_LIST: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}geofence/v1/list/{orgId}/{networkId}`
  },
  /** DELETE geofence — path geofence/v1/{geofenceId} */
  DELETE_GEOFENCE: {
    method: 'delete',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}geofence/v1/{geofenceId}`
  },
  /** GET geofence detail — path geofence/v1/detail/{geofenceId} */
  GET_GEOFENCE_DETAIL: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}geofence/v1/detail/{geofenceId}`
  },
  /** PUT update geofence — path geofence/v1/{geofenceId} */
  PUT_GEOFENCE: {
    method: 'put',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}geofence/v1/{geofenceId}`
  },
  // Share Diagnostics - Send diagnostic logs via email
  SHARE_DIAGNOSTICS: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/diagnostic/{deviceId}/{_Id}`
  },
  // Reboot device (AP/BR/PR/SW) - legacy resetRebootDevice: POST device/v1/resetReboot/{serial}/{deviceType}/{commandType}/{_Id}
  RESET_REBOOT_DEVICE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/resetReboot/{serial}/{deviceType}/{commandType}/{_Id}`
  },
  // Reboot MHS - legacy rebootMobileDevice: POST (insightmhs) device/v1/resetReboot/{_Id}/{organization_Id}/{deviceId}/MHS/{commandType}
  REBOOT_MOBILE_DEVICE: {
    method: 'post',
    url: `${preEnvUrl}device/v1/resetReboot/{_Id}/{organization_Id}/{deviceId}/MHS/{commandType}`
  },
  GET_SINGLE_ORG_DETAILS: {
    method: 'put',
    url: `${API_BASE_URL}organization/v1/deviceInfo/{_Id}/{orgId}/{page}{searchText}`
  },
  GET_USER_PREFERENCE_PAR_ORG: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/userpref/{_Id}/{tableView}/{orgId}`
  },
  SAVE_USER_PREFERENCE_PAR_ORG: {
    method: 'post',
    url: `${API_BASE_URL}unified/v1/userpref/{_Id}/{tableView}/{orgId}`
  },
  RENAME_DEVICE: {
    method: 'put',
    url: `${API_BASE_URL}device/v1/config/devices/{networkId}/{_Id}`
  },
  GET_LOC_DEVICE_DETAILS: {
    method: 'put',
    url: `${API_BASE_URL}device/v1/deviceList/{_Id}/{networkId}/{page}{searchText}`
  },
  GET_USER_PREFERENCE_LOCATION_LEVEL: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/userpref/{_Id}/{tableView}/{orgId}/{networkId}`
  },
  SAVE_USER_PREFERENCE_LOCATION_LEVEL: {
    method: 'post',
    url: `${API_BASE_URL}unified/v1/userpref/{_Id}/{tableView}/{orgId}/{networkId}`
  },
  DELETE_DEVICE: {
    method: 'delete',
    url: `${API_BASE_URL}unified/v1/deleteDevices/{_Id}/{scopeId}/{id}`
  },
  DELETE_DEVICE_ALL_LEVEL: {
    method: 'delete',
    url: `${API_BASE_URL}unified/v1/deleteDevices/{_Id}/{scopeId}`
  },
  // Legacy single-device delete: DELETE device/v2/{serial}/{_Id}, header networkId (AP/BR/PR/SW/MHS)
  DELETE_DEVICE_BY_SERIAL: {
    method: 'delete',
    url: `${API_BASE_URL}device/v2/{serial}/{_Id}`
  },
  Bulk_Validate_Add: {
    method: 'post',
    url: `${API_BASE_URL}bulk/v2/validateAdd/{_Id}/{orgId}/false`
  },
  getOrgLocationList: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/networkList/{_Id}/{orgId}`
  },
  // Move device — legacy device/v1/deviceMove/{_Id}/{deviceId}/{currentNetwork}/{organization_Id}
  SET_DEVICE_MOVE: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/deviceMove/{_Id}/{deviceId}/{sourceNetworkId}/{organization_Id}`
  },
  getProfileLocPerOrg: {
    method: 'get',
    url: `${preEnvUrl}organization/v1/networkDetails/{_Id}/{orgId}`
  },
  getDeviceSettings: {
    method: 'get',
    url: `${API_BASE_URL}bulk/v1/{_Id}/{orgId}`
  },
  postBulkAdd: {
    method: 'post',
    url: `${API_BASE_URL}bulk/v2/validateAdd/{_Id}/{orgId}/true`
  },
  // Global Search API Endpoints
  FETCH_GLOBAL_SEARCH_DATA: {
    method: 'get',
    url: `${GLOBAL_SEARCH_API_BASE_URL}globalSearch/v1/{searchType}/{_Id}/{searchQuery}`
  },
  FETCH_GLOBAL_SEARCH_HISTORY: {
    method: 'get',
    url: `${GLOBAL_SEARCH_API_BASE_URL}globalSearch/v1/globalSearchHistory/{_Id}`
  },
  DELETE_GLOBAL_SEARCH_HISTORY_ITEM: {
    method: 'delete',
    url: `${GLOBAL_SEARCH_API_BASE_URL}globalSearch/v1/globalSearchDeleteHistory/{_Id}/{searchValue}`
  },
  // Organization and Location APIs for global search
  GET_ORGANIZATION_LIST: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/orgList/{_Id}/{page}`
  },
  GET_LOCATION_PER_ORG: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/networkList/{_Id}/{orgId}/{page}/{active}`
  },
  GET_USER_ALARM: {
    method: 'get',
    url: `${API_BASE_URL}notification/v1/getUserAlarm/{_Id}/{page}`
  },
  MAKE_ALL_READ_NOTIFICATION: {
    method: 'post',
    url: `${API_BASE_URL}notification/v1/makeAllRead/{_Id}`
  },
  GET_DEVICE_IMAGES: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/deviceImages`
  },
  // Topology View
  TOPOLOGY_VIEW: {
    method: 'get',
    url: `${API_BASE_URL}unified/v1/topologyView/{_Id}/{scopeId}/{filterId}/{id}`
  },
  GET_SUPPORTED_FEATURE_LIST: {
    method: 'get',
    url: `${API_BASE_URL}public/v1/supportedFeatures/{_Id}`
  },
  GET_LAYOUT_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}user/v1/getCustomizeSettings/{_Id}`
  },
  SET_LAYOUT_STATUS: {
    method: 'post',
    url: `${API_BASE_URL}user/v1/setCustomizeSettings/{_Id}`
  },
  SHOW_HIDDEN_BANNER: {
    method: 'post',
    url: `${API_BASE_URL}user/v1/showHiddenBanner/{_Id}`
  },
  GET_ACCOUNT_CONTEXTS: {
    method: 'get',
    url: `${API_BASE_URL}user/v1/accountcontexts/{_Id}`
  },
  GET_SSID_INFO_LOCATION: {
    method: 'get',
    url: `${API_BASE_URL}network/v4/config/{networkId}/wirelessNetwork/{_Id}`
  },
  GET_SSID_INFO_ORG: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/wirelessorginfo/{_Id}/{orgId}`
  },
  GET_BAND_SUPPORTED_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/is6GhzSupported/{networkId}/{_Id}`
  },
  // notificationList: parent list = v2, child/correlated list = v1 (caller passes version in params)
  // {skipParams} carries cursor-based skip values (correlatedSkip, legacySkip) for v2 pagination — temporary, to be removed
  SHOW_NOTIFICATION_LIST: {
    method: 'post',
    url: `${API_BASE_URL}notification/{version}/notificationList/{_Id}/{alarmStatus}/{page}{searchText}{correlationId}{skipParams}{stackUuidParam}`
  },
  SHOW_DEVICE_NOTIFICATION_LIST: {
    method: 'post',
    url: `${API_BASE_URL}notification/{version}/notificationList/{_Id}/{alarmStatus}/{deviceId}/{page}{searchText}{correlationId}{skipParams}{stackUuidParam}`
  },
  // notification list
  GET_NOTIFICATION_LIST: {
    method: 'get',
    url: `${API_BASE_URL}notification/v1/notificationBell/{_Id}/all/0`
  },
  GET_NOTIFICATION_ALARM_COUNT: {
    method: 'get',
    url: `${API_BASE_URL}user/v2/alarmCount/{_Id}`
  },
  GET_NOTIFICATION_FILTERS: {
    method: 'get',
    url: `${API_BASE_URL}notification/v1/filters/{_Id}`
  },
  GET_LOC_FILTER_PER_ORG: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/networkinfo/{_Id}/{orgId}`
  },
  APPLY_NOTI_FILTERS: {
    method: 'post',
    url: `${API_BASE_URL}notification/v1/applyfilters/{_Id}`
  },
  DELETE_NOTIFICATION: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/notification/{_Id}`
  },
  MARK_ALL_AS_READ_NOTIFICATION: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/updatealarm/{_Id}`
  },
  SHARE_SELECTED_USER_ALARM: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/shareSelectedUserAlarm/{_Id}`
  },
  DELETE_SSID_BOTH_PLACES: {
    method: 'delete',
    url: `${API_BASE_URL}unified/v1/config/{_Id}/{scopeId}/{id}/deleteWirelessNetworks/`
  },
  GET_VLAN_LIST: {
    method: 'post',
    url: `${API_BASE_URL}vlan/v1/vlanList/{_Id}/{networkId}{groupId}/{page}{searchText}`
  },
  GET_VLAN_LIST_GROUP: {
    method: 'post',
    url: `${API_BASE_URL}vlan/v1/vlanList/{_Id}/{networkId}/{groupId}/{page}{searchText}`
  },
  GET_CLIENT_LIST_LOCATION_LEVEL: {
    method: 'post',
    url: `${API_BASE_URL}client/v3/{_Id}/{orgId}/{networkId}/{isConnected}/{page}{searchText}`
  },
  FIND_CLIENT_ON_FLOOR: {
    method: 'post',
    url: `${API_BASE_URL}client/v1/findClient/{_Id}/{orgId}/{networkId}`
  },
  GET_CLIENT_LIST_ORG_LEVEL: {
    method: 'post',
    url: `${API_BASE_URL}client/v3/{_Id}/{orgId}/{isConnected}/{page}{searchText}`
  },
  DELETE_DISCONNECTED_CLIENTS: {
    method: 'delete',
    url: `${API_BASE_URL}client/v2/deletedisconnectedclients/{_Id}/{orgId}/{networkId}/{deviceId}`
  },
  // Download Clients CSV (connected/disconnected based on isConnected param: 1 or 0)
  DOWNLOAD_CLIENT_LIST: {
    method: 'post',
    url: `${API_BASE_URL}client/v1/download/{orgId}/{_Id}/{networkId}/all/all/{isConnected}`
  },
  // Download Clients CSV - New API endpoint (with serialNo)
  DOWNLOAD_CLIENT_CSV: {
    method: 'post',
    url: `${API_BASE_URL}client/v1/clientCSV/{_Id}/{orgId}/{networkId}/{serialNo}/{isConnected}`
  },
  DELETE_VLAN: {
    method: 'delete',
    url: `${API_BASE_URL}wired/v1/config/deleteMultipleVlan/{_Id}/{networkId}{groupId}`
  },
  DELETE_VLAN_DEVICE_GROUP: {
    method: 'delete',
    url: `${API_BASE_URL}network/v1/config/{networkId}/vlan/{vlanId}/{_Id}{groupId}`
  },
  GET_CLIENT_ROAMING_HISTORY: {
    method: 'put',
    url: `${API_BASE_URL}client/v1/roaming/{_Id}/{orgId}/{networkId}/{wirelessNetworkId}/{macAddress}/{page}{searchText}`
  },
  GET_CLIENT_ROAMING_HISTORY_BY_CLIENT: {
    method: 'get',
    url: `${API_BASE_URL}client/v1/roamingByClient/{_Id}/{orgId}/{networkId}/{macAddress}/{page}`
  },
  CONNECTED_CLIENTS_WIRED: {
    method: 'put',
    url: `${API_BASE_URL}client/v1/{_Id}/{orgId}/{networkId}/{deviceSerial}/1/1/0{searchText}`
  },
  CONNECTED_CLIENTS_WIRELESS: {
    method: 'put',
    url: `${API_BASE_URL}client/v1/{_Id}/{orgId}/{networkId}/{deviceSerial}/0/1/0{searchText}`
  },

  POST_MOBILE_PROFILE: {
    method: 'post',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}profile/v1/{_Id}/{orgId}`
  },
  GET_CONFIG_BACKUP_LIST: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/getbackupinfo/{networkId}/{_Id}`
  },
  ADD_CONFIG_BACKUP: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/addconfig/{networkId}/{_Id}`
  },
  UPDATE_CONFIG_BACKUP: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/updateconfig/{backupId}/{_Id}`
  },
  MULTIPLE_DELETE_CONFIG_BACKUP: {
    method: 'delete',
    url: `${API_BASE_URL}backup/v2/deleteconfig/{_Id}`
  },
  DELETE_CONFIG_BACKUP: {
    method: 'delete',
    url: `${API_BASE_URL}network/v1/deleteconfig/{backupId}/{_Id}`
  },
  RESTORE_CONFIG_BACKUP: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/restorenetwork/{backupId}/{_Id}`
  },
  GET_VLAN_SSID: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/config/{networkId}/vlan/vlans/{_Id}{groupId}`
  },
  GET_MPSK_LIST: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/mpskList/{_Id}/{networkId}{groupId}`
  },
  DELETE_MPSK_GROUP: {
    method: 'delete',
    url: `${API_BASE_URL}network/v1/deleteMPSKGroup/{_Id}/{networkId}/{mpskGroupId}`
  },
  GET_MPSK_GROUP_LIST: {
    method: 'get',
    // url: `${API_BASE_URL}network/v1/getMPSKGroupList/{_Id}/{networkId}{groupId}`
    url: `${API_BASE_URL}network/v1/getMPSKGroupList/{_Id}/{networkId}`
  },
  GET_MPSK_GROUP_DETAILS: {
    method: 'get',
    // Legacy endpoint appended `{groupId}`; backend now needs only `_Id`, `networkId`, `mpskGroupId`
    url: `${API_BASE_URL}network/v1/getMPSKGroup/{_Id}/{networkId}/{mpskGroupId}`
  },
  SAVE_MPSK_PROFILE: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/saveMPSKProfile/{_Id}/{networkId}/{isEdit}{groupId}`
  },
  SAVE_MPSK_GROUP: {
    method: 'post',
    // Earlier endpoint expected `{groupId}` at the end; backend now requires only `_Id`, `networkId`, and `isEdit`
    url: `${API_BASE_URL}network/v1/saveOrUpdateMPSKGroup/{_Id}/{networkId}/{isEdit}`
  },
  DELETE_MPSK: {
    method: 'delete',
    url: `${API_BASE_URL}network/v1/mpsk/{_Id}/{networkId}/{keyName}{groupId}`
  },
  GET_IP_Config_ORG: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/natDefaultConfig/{_Id}`
  },
  GET_IP_Config_LOC: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/natDefaultConfig/{_Id}/{networkId}`
  },
  GET_FAST_ROMING: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/fastRoaming/{networkId}/{_Id}{groupId}`
  },
  // Authentication types the APs of this location cannot run.
  GET_SUPPORTED_AUTH_TYPES: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/supportedAuthTypes/{networkId}/{_Id}{groupId}`
  },
  GET_SCHEDULE_SSID: {
    method: 'get',
    url: `${API_BASE_URL}network/v2/schedulessid/{networkId}/{_Id}{groupId}`
  },
  GET_SCHEDULE_SSID_V3: {
    method: 'post',
    url: `${API_BASE_URL}wireless/v3/schedulessid/{_Id}/{networkId}/{groupId}/{page}{searchText}`
  },
  DELETE_SCHEDULE_SSID: {
    method: 'delete',
    url: `${API_BASE_URL}network/v1/deleteschedulessid/{networkId}/{scheduleId}/{_Id}{groupId}`
  },
  CREATE_SCHEDULE_SSID: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/createschedulessid/{networkId}/{_Id}{groupId}`
  },
  UPDATE_SCHEDULE_SSID: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/updateschedulessid/{networkId}/{scheduleId}/{_Id}{groupId}`
  },
  ADD_LOCATION_SSID: {
    method: 'post',
    url: `${API_BASE_URL}wireless/v1/addSsid/{_Id}/{orgId}/{networkId}`
  },
  GET_ROUTING_INFO: {
    method: 'post',
    url: `${API_BASE_URL}network/v2/config/{_Id}/routeInfo/{networkId}/{page}`
  },
  SET_STATIC_ROUTE: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/config/{networkId}/vlan/{vlanId}/staticRoute/{_Id}`
  },
  SET_GATEWAY: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/config/{networkId}/gateway/{_Id}`
  },
  GET_RADIUS_SERVER_CONFIG: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/radiusServerConfig/{_Id}`
  },
  SET_RADIUS_SERVER_CONFIG: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/radiusServerConfig/{_Id}`
  },
  GET_BR_SUMMARY_DATA: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/deviceInfo/{selectedDeviceId}/{selectedDeviceType}/dashboard/{_Id}`
  },
  GET_RADIO_CONFIG: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/radioconfig/{_Id}{groupId}`
  },
  SET_RADIO_CONFIG: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/radioconfig/{_Id}{groupId}`
  },
  //Add VLAN API Endpoints Start
  GET_MAC_CLIENTS: {
    method: 'get',
    url: `${API_BASE_URL}monitoring/v1/clients/{networkId}/connectedClients/{_Id}`
  },
  GET_MAC_ACL: {
    method: 'get',
    url: `${API_BASE_URL}network/v2/config/{networkId}/vlan/{vlanId}/aclSettings/{_Id}`
  },
  GET_VLAN_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}network/v3/config/{_Id}/{networkId}/vlan/{vlanId}{groupId}`
  },
  GET_SNMP_CONFIG: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/snmp/{_Id}/{networkId}`
  },
  GET_SNMP_ADVANCED_CONFIG: {
    method: 'get',
    url: `${API_BASE_URL}api/network/v1/snmp/{networkId}/user/{_Id}`
  },
  GET_PR_VLAN_ADVANCED_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}api/network/v1/vlanAdvancedSettings/{networkId}/user/{_Id}`
  },
  SET_PR_VLAN_ADVANCED_SETTINGS: {
    method: 'put',
    url: `${API_BASE_URL}api/network/v1/vlanAdvancedSettings/{networkId}/user/{_Id}`
  },
  GET_PR_SECURE_DNS_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}api/network/v1/secureDnsSettings/{networkId}/user/{_Id}`
  },
  SET_SNMP_CONFIG: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/snmp/{_Id}/{orgId}/{networkId}/{commandType}`
  },
  SET_SNMP_ADVANCED_CONFIG: {
    method: 'put',
    url: `${API_BASE_URL}api/network/v1/snmp/{networkId}/user/{_Id}`
  },
  SET_PR_SECURE_DNS_SETTINGS: {
    method: 'put',
    url: `${API_BASE_URL}api/network/v1/secureDnsSettings/{networkId}/user/{_Id}`
  },
  GET_NETWORK_LIST: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/vlannetworklist/{_Id}/{networkId}`
  },
  // VLAN Configuration API Endpoints Start
  GET_VLAN: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/config/{networkId}/vlan/vlans/{_Id}{groupId}`
  },
  GET_MANAGEMENT_VLAN: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/config/wireless/vlan/{_Id}/{orgId}{groupId}`
  },
  GET_MANAGEMENT_VLAN_WIRED: {
    method: 'get',
    url: `${API_BASE_URL}wired/v1/config/mgmtVlanConfig/{userId}/{networkId}`
  },
  UPDATE_MANAGEMENT_VLAN: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/updateconfig/wireless/vlan/{_Id}/{orgId}{groupId}`
  },
  GET_FAST_ROAMING: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/fastRoaming/{networkId}/{fastRoamingId}{groupId}`
  },
  SET_FAST_ROAMING: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/fastRoaming/{networkId}/{status}/{fastRoamingId}{groupId}`
  },
  GET_NETWORK_PORT_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}monitoring/v1/{networkId}/swConnectedNeighborsList/{_Id}{groupId}`
  },
  GET_DEVICE_LIST_VLAN: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/vlandevices/{_Id}/{orgId}/{networkId}{groupId}`
  },
  GET_CUSTOM_GROUP_DEVICES: {
    method: 'get',
    url: `${API_BASE_URL}device/v6/devices/{networkId}/{_Id}{groupId}`
  },
  GET_NETWORK_LEVEL_PORT_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}monitoring/v1/{networkId}/swConnectedNeighborsList/{_Id}`
  },
  GET_SPANNING_TREE_INFO: {
    method: 'get',
    url: `${API_BASE_URL}network/v3/spanningTreeInfo/{_Id}`
  },
  GET_DEVICE_LIST: {
    method: 'get',
    url: `${API_BASE_URL}device/v5/devices/{networkId}/{_Id}`
  },
  GET_SWITCH_MODEL_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}public/v1/models/im`
  },
  GET_RADIUS_CONFIGURATION: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/devices/{networkId}/devices/sw/{_Id}{groupId}`
  },
  GET_LOCATION_DASHBOARD_SWITCH_LAG: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/config/{networkId}/lagGroups/{_Id}{groupId}`
  },
  GET_ARSCONFIG: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/arsconfig/{_Id}/{networkId}{groupId}`
  },
  NETWORK_LIST: {
    method: 'get',
    url: `${API_BASE_URL}network/v4/networks/{accountId}/{_Id}`
  },
  ADD_VLAN: {
    method: 'post',
    url: `${API_BASE_URL}network/v2/config/{networkId}/vlan/{_Id}{groupId}`
  },
  EDIT_VLAN: {
    method: 'put',
    url: `${API_BASE_URL}network/v2/config/{networkId}/vlan/{_Id}{groupId}`
  },
  CONFIGURE_VLAN_MEMBERS_POST: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/config/{networkId}/vlan/{vlanId}/vlanMembers/{_Id}{groupId}`
  },
  CONFIGURE_VLAN_MEMBERS_PUT: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/config/{networkId}/vlan/{vlanId}/vlanMembers/{_Id}{groupId}`
  },
  RADIUS_CONFIGURATION: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/{networkId}/wiredRadiusAuth/{_Id}{groupId}`
  },
  GET_ICM_ELIGIBILITY: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/icmEligibility/{networkId}/{_Id}`
  },
  GET_AUTO_RF_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/nwRFSettings/{networkId}/{_Id}{groupId}`
  },
  GET_DEVICE_LIST_AP: {
    method: 'get',
    url: `${API_BASE_URL}device/v5/devices/{networkId}/AP/{_Id}`
  },
  GET_DEVICE_LIST_AP_GROUP: {
    method: 'get',
    url: `${API_BASE_URL}device/v6/devices/{networkId}/AP/{_Id}{groupId}`
  },
  GET_DEVICE_FIRMWARE_LIST: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/fwUpgrade/device/{networkId}/{_Id}/{page}{searchText}`
  },
  GET_CURRENT_FIRMWARE_TYPE: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/currentFWType/{networkId}/{_Id}`
  },
  UPDATE_DEVICE_FIRMWARE: {
    method: 'put',
    url: `${API_BASE_URL}device/v2/fwUpgrade/1/{networkId}/{_Id}`
  },
  UPDATE_DEVICE_TEST_FIRMWARE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/testFwUpgrade/device/{networkId}/{_Id}/testFirmware`
  },
  UPDATE_ALL_DEVICE_FIRMWARE: {
    method: 'put',
    url: `${API_BASE_URL}device/v2/fwUpgrade/2/{networkId}/{_Id}`
  },
  GET_FIRMWARE_POLICY: {
    method: 'get',
    url: `${API_BASE_URL}scheduler/v1/{networkId}/getJob/firmwarePolicyJobs/{_Id}{groupId}`
  },
  CREATE_FIRMWARE_POLICY: {
    method: 'post',
    url: `${API_BASE_URL}scheduler/v1/{networkId}/setJob/firmwarePolicyJobs/{_Id}{groupId}`
  },
  UPDATE_FIRMWARE_POLICY: {
    method: 'put',
    url: `${API_BASE_URL}scheduler/v1/{networkId}/updateJob/firmwarePolicyJobs/{_Id}{groupId}`
  },
  GET_FIRMWARE_UPDATE_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/devicefwUpdateStatus/2/{networkId}/{_Id}`
  },
  GET_TARGET_FIRMWARE_LIST: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/fwTargetSelection/fwUpgrade/{_Id}{orgPath}/{networkId}`
  },
  GET_TARGET_FIRMWARE_LIST_V2: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/fwTargetSelection/{_Id}/{orgId}/{networkId}`
  },
  SET_TARGET_FIRMWARE_LIST: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/fwTargetSelection/fwUpgrade/{_Id}{orgPath}/{networkId}`
  },
  GET_INSTANT_WIFI_SCHEDULER: {
    method: 'get',
    url: `${API_BASE_URL}scheduler/v1/{networkId}/getJob/instantWifi/{_Id}{groupId}`
  },
  SET_INSTANT_AUTO_RF_STATUS: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/nwRFSettings/{networkId}/instantWiFiConfig/{configType}/{requestType}/{_Id}{groupId}`
  },
  // Instant WiFi Optimization Settings in one request; the body carries only the blocks the user changed.
  SAVE_INSTANT_WIFI_OPTIMIZATION_SETTINGS: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/instantWiFi/{networkId}/optimizationSettings/{_Id}`
  },
  OPTIMIZE_NOW_AUTO_RF: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/runNowAutoRf/{networkId}/{_Id}/true{groupId}`
  },
  RADIO_INFO: {
    method: 'get',
    // Path matches the rfChannel call that returns frequency2_4 / frequency5 / frequency2_6 arrays
    url: `${API_BASE_URL}device/v2/rfChannel/{networkId}/{serialNo}/{_Id}`
  },

  // Legacy save endpoint for RF settings (aggregated per-device list)
  SET_RADIO_SETTING_OF_DEVICES: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/rfChannel/{networkId}/{_Id}`
  },

  UPDATE_FIRMWARE_POLICY_FOR_INSTANS_WIFI: {
    method: 'post',
    url: `${API_BASE_URL}scheduler/v1/{networkId}/setJob/instantWifi/{_Id}{groupId}`
  },
  UPDATE_FIRMWARE_POLICY_FOR_INSTANS_WIFI_PUT: {
    method: 'put',
    url: `${API_BASE_URL}scheduler/v1/{networkId}/updateJob/instantWifi/{_Id}{groupId}`
  },

  // MAC ACL Endpoints
  POST_MAC_STATUS: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/config/{networkId}/vlan/{vlanId}/macAuth/{_Id}`
  },
  POST_MAC_AUTHENTICATION_PUT: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/config/{networkId}/vlan/{vlanId}/aclSettings/{_Id}{groupId}`
  },
  POST_MAC_AUTHENTICATION_POST: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/config/{networkId}/vlan/{vlanId}/aclSettings/{_Id}{groupId}`
  },
  DELETE_MAC_AUTHENTICATION: {
    method: 'delete',
    url: `${API_BASE_URL}network/v1/config/{networkId}/vlan/{vlanId}/macAclSettings/{_Id}{groupId}`
  },
  POST_IP_FILTERING_STATUS: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/config/{networkId}/vlan/{vlanId}/ipAuth{groupId}`
  },
  POST_IP_FILTERING_EDIT: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/config/{networkId}/vlan/{vlanId}/ipAclSettings/{_Id}{groupId}`
  },
  POST_IP_FILTERING_POST: {
    method: 'post',
    url: `${API_BASE_URL}network/v2/config/{networkId}/vlan/{vlanId}/ipAclSettings/{_Id}{groupId}`
  },
  DELETE_IP_FILTERING: {
    method: 'delete',
    url: `${API_BASE_URL}network/v2/config/{networkId}/vlan/{vlanId}/ipAclSettings/{_Id}{groupId}`
  },
  // SSID Endpoints
  DELETE_SSID: {
    method: 'delete',
    url: `${API_BASE_URL}network/v1/config/{networkId}/wirelessNetwork/{ssidId}/{_Id}{groupId}`
  },
  ADD_SSID: {
    method: 'post',
    url: `${API_BASE_URL}network/v3/config/{networkId}/vlan/wirelessNetwork/{_Id}{groupId}`
  },
  UPDATE_SSID_DETAILS: {
    method: 'put',
    url: `${API_BASE_URL}network/v3/config/{networkId}/wirelessNetwork/{ssidId}/{_Id}{groupId}`
  },
  SAVE_FB_WIFI_SETTINGS: {
    method: 'put',
    url: `${API_BASE_URL}wireless/v1/facebookWifi/{networkId}/{ssidId}`
  },
  UPDATE_CP: {
    method: 'post',
    url: `${API_BASE_URL}wireless/v1/captivePortal/{networkId}`
  },
  // VLAN IP Configuration Endpoints
  DELETE_STATIC_ROUTING_INFO: {
    method: 'delete',
    url: `${API_BASE_URL}network/v1/config/{networkId}/vlan/{vlanId}/staticRoute/{groupId}`
  },
  ENABLE_DHCP: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/dynamicroute/{_Id}/{networkId}/{vlanId}`
  },
  SET_STATIC_ROUTING_INFO: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/config/{networkId}/vlan/{vlanId}/staticRoute/{_Id}{groupId}`
  },

  //Syslog Settings Endpoints
  LOCATION_SETTINGS_SYSLOG_CONFIGURATION: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/getSysLogSettings/{currentNetwork}/{_Id}`
  },
  LOCATION_SETTINGS_UPDATE_SYSLOG_CONFIGURATION: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/setSysLogSettings/{currentNetwork}/{_Id}`
  },

  // DHCP Server Endpoints
  GET_DHCP_SERVER_LIST: {
    method: 'get',
    url: `${API_BASE_URL}router/v2/dhcpconfig/{brDeviceId}/{_Id}`
  },
  SAVE_BR_LAN_IP_DATA_DHCP: {
    method: 'post',
    url: `${API_BASE_URL}router/v2/dhcpconfig/{brSerial}/{commandType}/{_Id}`
  },
  // Network Sharing Endpoints
  SET_NETWORK_SHARING_CREATE: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/config/{brDevice}/networkSharing/create`
  },
  SET_NETWORK_SHARING_DELETE: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/config/{brDevice}/networkSharing/delete`
  },
  // ADD VLAN API Endpoints End
  GET_EDIT_API_DETAILS: {
    method: 'post',
    url: `${API_BASE_URL}wireless/v1/updateSsid/{_Id}/{orgId}/{networkId}/{wirelessNetworkId}`
  },
  GET_PAR_SSID_INFO: {
    method: 'get',
    url: `${API_BASE_URL}network/v4/config/{networkId}/wirelessNetwork/{wirelessNetworkId}/{orgId}/{_Id}`
  },
  GET_SWITCH_INFO: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/devices/{networkId}/devices/sw/{_Id}{groupId}`
  },
  GET_LOCATION_DASHBOARD_SWITCH_LAG_DATA: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/config/{networkId}/lagGroups/{_Id}`
  },
  SET_SPANNING_TREE_INFO: {
    method: 'post',
    url: `${API_BASE_URL}network/v3/config/spanningTree/{_Id}`
  },
  // Device Groups API Endpoints
  GET_DEVICE_GROUPS: {
    method: 'put',
    url: `${API_BASE_URL}deviceGroups/v2/groups/{_Id}/{networkId}/{page}{searchText}`
  },
  ADD_DEVICE_GROUP: {
    method: 'post',
    url: `${API_BASE_URL}deviceGroups/v2/{_Id}/{networkId}`
  },
  UPDATE_DEVICE_GROUP: {
    method: 'post',
    url: `${API_BASE_URL}deviceGroups/v1/update/{_Id}/{orgId}/{networkId}/{customGroupId}`
  },
  FETCH_SNMP_SERVER_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/snmpServer/{_Id}/{selectedDeviceId}`
  },
  SAVE_SNMP_SERVER_DETAILS: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/snmpServer/{_Id}/{selectedDeviceId}/{organization_Id}`
  },

  // ==============================|| mDNS Gateway Endpoints ||============================== //
  // These mirror mdns service routes. All require {_Id}/{orgId}/{networkId}
  // Defaults/shared lists
  // Policies list
  // Discovered services (AP or PR device)
  // Status toggle
  // Add/Edit policy
  // Policy details for edit
  // Delete policy
  DELETE_DEVICE_GROUP: {
    method: 'delete',
    url: `${API_BASE_URL}deviceGroups/v2/deviceGroup/deleteMultiple/{_Id}/{networkId}`
  },
  GET_SWITCHINFO: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/switchInfo/{networkId}`
  },
  GET_ORG_WIDE_SSID_INFO: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/wirelessorginfo/{_Id}/{orgId}/{wirelessNetworkId}`
  },
  GET_SWITCH_SUMMARY_DATA: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/deviceInfo/{deviceId}/SW/dashboard/{_Id}`
  },
  TEST_SELECTED_PORTS_SWITCH: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/config/{deviceId}/SW/cabletest/{_Id}/{orgId}`
  },
  GET_TEST_RESULT_SWITCH: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/deviceInfo/{deviceId}/SW/cabletest/{_Id}`
  },
  GET_CNSWITCH: {
    method: 'get',
    url: `${API_BASE_URL}monitoring/v1/{serial}/SW/connectedNeighbors/{_Id}`
  },
  GET_PORT_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}monitoring/v1/{serial}/connectedNeighborsList/{_Id}`
  },
  GET_SWITCH_CN_SUMMARY: {
    method: 'get',
    url: `${API_BASE_URL}monitoring/v1/{serial}/SW/{port}/connectedNeighborsList/{_Id}`
  },
  SATELLITE_LIVE_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}/device/v3/platformClients/{deviceId}/{_Id}`
  },
  GET_WIRELESS_SSID_INFO: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/config/{networkId}/{wirelessNetworkId}/{_Id}`
  },
  GET_MAC_ACL_RADIUS_CONFIG: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/radiusServerConfig/{_Id}`
  },
  GET_RECENT_CLIENTS: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/recentClients/{networkId}/{pageInfo}/{_Id}`
  },
  GET_CONNECTED_CLIENTS_MAC_ACL: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/connectedClients/{networkId}/{_Id}`
  },
  FETCH_SNMP_TRAP_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/snmpTrap/{_Id}/{selectedDeviceId}`
  },
  SAVE_SNMP_TRAP_DETAILS: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/snmpTrap/{_Id}/{selectedDeviceId}/{organization_Id}`
  },
  DOWNLOAD_MIBS_DATA: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/snmpMib/{selectedDeviceId}/{_Id}`
  },
  DEFAULT_ECP_SERVICES: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/defaultECPServices/{_Id}/{networkId}`
  },
  GET_SYSTEM_HEALTH_CONFIG_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/systemHealthConfigDetails/{_Id}/{networkId}`
  },
  AUTH_USER_FROM_OC: {
    method: 'post',
    url: `${API_BASE_URL}user/v1/authUserFromOC/{_Id}`
  },
  REVEAL_CREDENTIALS: {
    method: 'post',
    url: `${API_BASE_URL}user/v1/credentials/reveal/{_Id}`
  },
  // DHCP Server APIs
  GET_DHCP_SERVER_LIST_PR: {
    method: 'get',
    url: `${API_BASE_URL}router/v3/dhcpconfig/{firstDynamicParameter}/{_Id}`
  },
  GET_DHCP_LEASE_INFO: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/dhcpLeases/{selectedDeviceId}/{_Id}`
  },
  DHCP_REVOKE: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v2/dhcpRevoke/{_Id}/{selectedDeviceId}/{organization_Id}`
  },
  DHCPV6_REVOKE: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v2/dhcpv6Revoke/{_Id}/{selectedDeviceId}/{organization_Id}`
  },
  PR_TRAFFIC_DATA: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/trafficStatistics/{_Id}/{selectedDeviceId}/{firstDynamicParameter}{secondDynamicParameter}`
  },
  DEVICE_CONNECTIVITY: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/connectivityStatus/{_Id}/{selectedDeviceId}`
  },
  ROUTER_DASH_DATA: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/routerDash/{_Id}/{networkId}/{selectedDeviceId}`
  },
  PR_CLIENTS_GRAPH: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/connClientsGraph/{selectedDeviceId}/{_Id}/{organization_Id}/{firstDynamicParameter}`
  },
  // Port Configuration APIs
  GET_PORT_CONFIGURED_VLAN: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/prPortInfo/{_Id}/{selectedDeviceId}/{port}`
  },
  GET_LLDP_DATA: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getLldp/{_Id}/{selectedDeviceId}`
  },
  SET_VLAN_IDS_LIST_PR: {
    method: 'put',
    url: `${API_BASE_URL}pr/v2/vlanMembers/{_Id}/{selectedDeviceId}/{organization_Id}`
  },
  SET_LLDP_DATA: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/lldpConfigure/{_Id}/{selectedDeviceId}/{organization_Id}`
  },
  // Access Point IP Settings API Endpoints
  GET_AP_IP_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/config/{deviceId}/AP/ipSetting/{_Id}`
  },
  UPDATE_AP_IP_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/config/{deviceId}/AP/ipSetting/{_Id}/{organization_Id}`
  },
  GET_SW_IP_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/config/{deviceId}/SW/deviceIpSettings/{_Id}`
  },
  UPDATE_SW_IP_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/config/{deviceId}/SW/deviceIpSettings/{_Id}/{organization_Id}`
  },
  // VLAN APIs
  GET_DEVICE_LEVEL_VLAN: {
    method: 'get',
    url: `${API_BASE_URL}network/v2/config/{firstDynamicParameter}/vlan/vlans/{_Id}/{selectedDeviceId}`
  },
  DELETE_PR_VLAN: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v3/config/vlan/{_Id}/{organization_Id}/{selectedDeviceId}`
  },
  // AP Statistics API Endpoints
  GET_AP_STATISTICS: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/apstatistics/{_Id}/{deviceId}`
  },
  CLEAR_AP_STATISTICS: {
    method: 'delete',
    url: `${API_BASE_URL}device/v1/apstatistics/{_Id}/{deviceId}`
  },
  // Access Point Device Page APIs
  GET_AP_DEVICE_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/deviceInfo/{deviceId}/AP/dashboard/{_Id}`
  },
  GET_DEVICE_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/deviceInfo/{deviceId}/AP/about/{_Id}`
  },
  // Locate device (cloud LED blink) — device/v1/getBlueLedSettings
  GET_BLUE_LED: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/getBlueLedSettings/{_Id}/{deviceId}`
  },
  // Locate device — device/v1/setBlueLedSettings; commandType: start | stop
  SET_BLUE_LED: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/setBlueLedSettings/{_Id}/{deviceId}/{commandType}`
  },
  // DHCP Failures API Endpoints
  GET_DHCP_FAILURES: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/deviceInfo/{deviceId}/AP/dhcp-failures/{_Id}`
  },
  GET_DHCP_FAILURE_TIMELINE: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/deviceInfo/{deviceId}/AP/dhcp-failure-timeline/{_Id}`
  },
  // URL Filtering API Endpoints
  GET_URL_FILTER: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/config/{networkId}/urlFilter/{urlFilterId}`
  },
  POST_URL_FILTER: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/config/{networkId}/urlFilter/{urlFilterId}`
  },
  DELETE_URL_FILTER: {
    method: 'delete',
    url: `${API_BASE_URL}network/v1/config/{networkId}/urlFilter/{urlFilterId}`
  },
  // Mesh Network Settings API Endpoints
  // Base URL: meshSettings/{networkId}/{orgId}
  // With device group: meshSettings/{networkId}/{orgId}/group/{groupId}
  GET_MESH_NETWORK_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/config/meshSettings/{networkId}/{orgId}{groupId}`
  },
  PUT_MESH_NETWORK_SETTINGS: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/updateconfig/meshSettings/{networkId}/{orgId}{groupId}`
  },
  // RF Profile endpoints
  GET_RF_PROFILE: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/rfProfile/{_Id}/{orgId}/{networkId}/profile/RF`
  },
  GET_RF_PROFILE_WITH_PAGINATION: {
    method: 'post',
    url: `${API_BASE_URL}wireless/v1/rfProfile/{_Id}/{orgId}/{networkId}/profile/{profileType}/{page}{searchText}`
  },
  GET_CUSTOMER_PROFILE: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/rfProfile/{_Id}/{orgId}/{networkId}/profile/CPF`
  },
  GET_RF_PROFILE_DETAIL: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/rfProfile/{_Id}/{orgId}/{networkId}/{profileId}`
  },
  GET_TRAFFIC_TREND_DATA: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/trafficTrendData/{deviceId}/{timeRange}/{_Id}`
  },
  GET_PLATFORM_CLIENTS: {
    method: 'get',
    url: `${API_BASE_URL}/device/v3/platformClients/{deviceId}/{_Id}`
  },
  SAVE_LAG: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/config/{networkId}/lagGroups/{_Id}`
  },
  DELETE_LAG: {
    method: 'delete',
    url: `${API_BASE_URL}network/v1/config/{networkId}/{lagId}/lagGroups/{_Id}`
  },
  UPDATE_LAG: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/config/{networkId}/lagGroups/{_Id}`
  },
  // ==============================|| mDNS Gateway Endpoints ||============================== //
  // These mirror mdns service routes. All require {_Id}/{orgId}/{networkId}
  // Defaults/shared lists
  MDNS_GET_DEFAULTS: {
    method: 'get',
    url: `${API_BASE_URL}mdns/v1/sharedService/wirelessNetwork/{_Id}/{orgId}/{networkId}`
  },
  // Policies list
  MDNS_GET_POLICIES: {
    method: 'get',
    url: `${API_BASE_URL}mdns/v1/policy/{_Id}/{orgId}/{networkId}`
  },
  // Discovered services (AP or PR device)
  MDNS_DISCOVERED_SERVICES: {
    method: 'get',
    url: `${API_BASE_URL}mdns/v1/discoveredService/{_Id}/{Organization_Id}/{networkId}/{device}`
  },
  // Status toggle
  MDNS_UPDATE_STATUS: {
    method: 'put',
    url: `${API_BASE_URL}mdns/v1/updateMdns/{_Id}/{orgId}/{networkId}`
  },
  // Add/Edit policy
  MDNS_ADD_OR_EDIT_POLICY: {
    method: 'post',
    url: `${API_BASE_URL}mdns/v1/policy/{_Id}/{orgId}/{networkId}/{isEdit}`
  },
  // Policy details for edit
  MDNS_GET_EDITED_POLICY_DETAILS: {
    method: 'put',
    url: `${API_BASE_URL}mdns/v1/policy/{_Id}/{orgId}/{networkId}`
  },
  // Delete policy
  MDNS_DELETE_POLICY: {
    method: 'delete',
    url: `${API_BASE_URL}mdns/v1/policy/{_Id}/{orgId}/{networkId}`
  },
  GET_ADVANCED_NETWORK_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/broadcasttounicast/{_Id}/{networkId}{groupId}`
  },
  UPDATE_ADVANCED_NETWORK_SETTINGS: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/broadcasttounicast/{_Id}/{networkId}{groupId}`
  },
  SET_BROADCASTTOUNICAST: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/broadcasttounicast/{networkId}/broadcastToUnicast/{_Id}`
  },
  GET_LOAD_BALANCING_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/loadbalancing/{_Id}/{networkId}{groupId}`
  },
  SET_LOAD_BALANCING_STATUS: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/loadbalancing/{_Id}/{networkId}{groupId}`
  },
  GET_POE_PORT_CONFIG: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/deviceInfo/{deviceId}/SW/poePortConfig/{_Id}`
  },
  SET_POE_PORT_CONFIG: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/config/{deviceId}/SW/poePortConfig/{_Id}/{organization_Id}`
  },
  GET_PM_SWITCH: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/config/{deviceId}/SW/devicePortMirroring/{_Id}`
  },
  SAVE_SWITCH_PORT_MIRRORING: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/config/{deviceId}/SW/devicePortMirroring/{_Id}/{organization_Id}`
  },
  // AP Radio Settings API Endpoints
  SET_RADIO_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/rfChannel/{networkId}/{serialNo}/{_Id}`
  },
  // Secure Diagnostic Mode APIs
  GET_SDM_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/sdmstatus/{_Id}/{selectedDeviceId}`
  },
  SAVE_SDM_DETAILS: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/sdmstatus/{_Id}/{selectedDeviceId}`
  },
  // Device Backup APIs
  GET_DEVICE_BACKUP_LIST_RMA: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/getbackupinfo/{firstDynamicParameter}/{_Id}`
  },
  CHECK_FIRMWARE_COMPATIBILITY: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/fwcompatibilty/{_Id}/{secondDynamicParameter}/{thirdDynamicParameter}/{selectedDeviceSerial}`
  },
  // RMA APIs
  GET_DEVICE_LIST_WITH_BACKUP: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/devicelist/{networkId}/{selectedDeviceSerial}/{_Id}`
  },
  RMA_RESTORE_REPLACE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/rmadeviceconfigs/{_Id}`
  },
  GET_STACK_LIST_WITH_BACKUP: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/stacklist/{networkId}/{serialNo}/{_Id}`
  },
  RMA_STACK_RESTORE_REPLACE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/rmastackconfigs/{_Id}`
  },
  GET_BACKUP_PROGRESS: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/getprogress/{firstDynamicParameter}/`
  },
  RESTORE_DEVICE_BACKUP: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/restoredevice/{firstDynamicParameter}/{_Id}`
  },
  GET_DEVICE_BACKUP_LIST: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/getbackupinfo/{firstDynamicParameter}/{_Id}`
  },
  DELETE_DEVICE_BACKUP: {
    method: 'delete',
    url: `${API_BASE_URL}device/v1/deleteconfig/{firstDynamicParameter}/{_Id}`
  },
  ADD_DEVICE_BACKUP: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/addconfig/{firstDynamicParameter}/{_Id}`
  },
  UPDATE_DEVICE_BACKUP: {
    method: 'put',
    url: `${API_BASE_URL}device/v1/updateconfig/{backupId}/{_Id}`
  },
  DOWNLOAD_DEVICE_BACKUP: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/downloadconfigfile/{backupId}/{_Id}`
  },
  UPLOAD_DEVICE_BACKUP: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/uploadconfigfile/{selectedDeviceSerial}/{_Id}`
  },
  // Access Point Diagnostic Mode (SDM) API Endpoints
  GET_AP_DIAGNOSTIC_MODE: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/sdmstatus/{_Id}/{deviceId}`
  },
  // DNS Lookup Test API Endpoints
  GET_DNS_LOOKUP: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/dnstest/{_Id}/{orgId}/{networkId}/{deviceId}`
  },
  SET_DNS_LOOKUP: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/dnstest/{_Id}/{orgId}/{networkId}`
  },
  // Ping Test API Endpoints
  GET_PING_TEST: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/pingtest/{_Id}/{orgId}/{networkId}/{deviceId}`
  },
  SET_PING_TEST: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/troubleshoot/{_Id}/{orgId}/{networkId}`
  },
  // Traceroute Test API Endpoints
  GET_TRACEROUTE_TEST: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/traceroutetest/{_Id}/{orgId}/{networkId}/{deviceId}`
  },
  GET_TRACEROUTE: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/traceroute/{_Id}/{orgId}/{networkId}/{deviceId}`
  },
  SET_TRACEROUTE_TEST: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/troubleshoot/{_Id}/{orgId}/{networkId}`
  },
  GET_SWITCH_DASHBOARD_STATISTICS: {
    method: 'get',
    url: `${API_BASE_URL}monitoring/v1/{serial}/SW/dashboardStatistics/{_Id}`
  },
  GET_SWITCH_POE_PORTS: {
    method: 'get',
    url: `${API_BASE_URL}monitoring/v1/{serial}/SW/poePorts/{_Id}`
  },
  CLEAR_SWITCH_COUNTERS: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/resetReboot/{serial}/SW/clearCounter/{_Id}`
  },
  GET_SUBSCRIPTION_PLAN_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}user/v2/subscriptionPlans/{_Id}`
  },
  GET_SUBSCRIPTION_HISTORY: {
    method: 'get',
    url: `${API_BASE_URL}user/v1/creditSummary/{_Id}`
  },
  /** LMS Apex plan eligibility: GET user/v1/featureStatus/{_Id}/Apex — 1 = enabled, 0 = not */
  GET_APEX_FEATURE_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}user/v1/featureStatus/{_Id}/Apex`
  },
  /** PAYG device-day credits preview: keys to convert (`details.count`) and total device days (`details.total`) */
  GET_USER_LICENSES_CONVERSION_SUMMARY: {
    method: 'get',
    url: `${API_BASE_URL}user/v1/licenses/{_Id}`
  },
  CHECKOUT_SUBSCRIPTION: {
    method: 'post',
    url: `${API_BASE_URL}user/v2/checkout/{_Id}`
  },
  CANCEL_SUBSCRIPTION: {
    method: 'put',
    url: `${API_BASE_URL}user/v2/cancelSubscription/{_Id}`
  },
  IS_FIVE_YEAR_CUTOVER_PENDING: {
    method: 'get',
    url: `${API_BASE_URL}user/v2/isFiveYearCutoverPending/{_Id}`
  },
  CANCEL_FIVE_YEAR_QUANTITY_SCHEDULE: {
    method: 'post',
    url: `${API_BASE_URL}user/v2/cancelFiveYearQuantitySchedule/{_Id}`
  },
  GET_ALLOC_CREDIT_INFO: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/alloccredit/{_Id}/{orgId}`
  },
  ALLOC_CREDIT: {
    method: 'post',
    url: `${API_BASE_URL}organization/v2/alloccredit/{_Id}/{orgId}`
  },
  DEALLOC_CREDIT: {
    method: 'post',
    url: `${API_BASE_URL}organization/v2/deallocorgcredit/{_Id}`
  },
  GET_ORGANIZATION_POOLS: {
    method: 'post',
    // Append {searchText} so useApi can substitute `?searchText=...` (same pattern as GET_INVOICES).
    url: `${API_BASE_URL}license/v2/creditManagement/{_Id}/{pageno}{searchText}`
  },
  GET_INVOICES: {
    method: 'post',
    url: `${API_BASE_URL}invoice/v1/invoices/{_Id}/{page}{searchText}`
  },
  DOWNLOAD_INVOICE: {
    method: 'post',
    url: `${API_BASE_URL}user/v2/downloadInvoice/{_Id}`
  },
  /** Invoice history from ARIA, for users migrated from ARIA billing (Purchase History → ARIA Invoices) */
  GET_ARIA_INVOICES: {
    method: 'get',
    url: `${API_BASE_URL}user/v1/ariaInvoices/{_Id}`
  },
  DOWNLOAD_ARIA_INVOICE: {
    method: 'post',
    url: `${API_BASE_URL}user/v1/downloadAriaInvoice/{_Id}`
  },
  GET_LMS_CREDIT_MANAGEMENT: {
    method: 'get',
    url: `${API_BASE_URL}license/v2/creditManagement/{_Id}/{firstDynamicParameter}/CreditManagement/1/{pageno}{searchTextQuery}`
  },
  /** Allocation breakdown by license - used when opening Allocation To drawer */
  GET_LMS_CREDIT_MANAGEMENT_BY_ORG: {
    method: 'get',
    url: `${API_BASE_URL}license/v1/creditManagement/{_Id}/licenseView/CreditManagement/1/{pageno}/{licenseId}`
  },
  /** Hard bundled devices list - paginated with search and multi-column filter */
  /** Hard bundled devices list - paginated with search and multi-column filter */
  GET_HARD_BUNDLES: {
    method: 'post',
    url: `${API_BASE_URL}license/v1/hardbundles/{_Id}/{page}{searchTextQuery}`
  },
  GET_ALLOCATED_SUBSCRIPTIONS: {
    method: 'get',
    url: `${API_BASE_URL}license/v2/licensesByStatus/{_Id}/ALLOCATED`
  },
  GET_UNALLOCATED_SUBSCRIPTIONS: {
    method: 'get',
    url: `${API_BASE_URL}license/v2/licensesByStatus/{_Id}/UNALLOCATED`
  },
  GET_SCHEDULED_SUBSCRIPTIONS: {
    method: 'get',
    url: `${API_BASE_URL}license/v2/licensesByStatus/{_Id}/SCHEDULED`
  },
  GET_GRACE_SUBSCRIPTIONS: {
    method: 'get',
    url: `${API_BASE_URL}license/v2/licensesByStatus/{_Id}/GRACE`
  },
  GET_EXPIRING_SUBSCRIPTIONS: {
    method: 'get',
    url: `${API_BASE_URL}license/v2/licensesByStatus/{_Id}/EXPIRING`
  },
  GET_HARDBUNDLE_SUBSCRIPTIONS: {
    method: 'get',
    url: `${API_BASE_URL}license/v2/licensesByStatus/{_Id}/HARDBUNDLE`
  },
  GET_EXPIRED_SUBSCRIPTIONS: {
    method: 'get',
    url: `${API_BASE_URL}license/v2/licensesByStatus/{_Id}/EXPIRED`
  },
  // License Key APIs
  GET_LICENSE_KEY_INFO: {
    method: 'post',
    url: `${API_BASE_URL}license/v1/getLicenseKeyInfo/{_Id}/{purchaseType}`
  },
  GET_DEVICES_LICENSE_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}license/v1/devices/license-status/{_Id}?family={family}&networkId={networkId}`
  },
  GET_SUBSCRIPTIONS_SUMMARY: {
    method: 'get',
    url: `${API_BASE_URL}license/v1/subscriptions/summary/{_Id}`
  },
  GET_LICENSE_SEGMENT: {
    method: 'get',
    url: `${API_BASE_URL}license/v1/segment/{_Id}?licKey={licKey}`
  },
  ASSIGN_LICENSE_KEY_TO_DEVICE: {
    method: 'post',
    url: `${API_BASE_URL}license/v1/assign/{_Id}`
  },
  ASSIGN_LICENSE_KEY_TO_SASE_ORG: {
    method: 'post',
    url: `${API_BASE_URL}license/v1/assign/org/{_Id}`
  },
  VALIDATE_SASE_ORG_ASSIGNMENT: {
    method: 'post',
    url: `${API_BASE_URL}license/v1/assign/org/validate/{_Id}`
  },
  GET_SASE_ORG_POOLS: {
    method: 'get',
    url: `${API_BASE_URL}license/v1/sase/orgs/{_Id}`
  },
  ADD_PENDING_LICENSE: {
    method: 'post',
    url: `${API_BASE_URL}license/v1/pending/{_Id}`
  },
  ADD_LICENSE_KEY: {
    method: 'post',
    url: `${API_BASE_URL}license/v1/{_Id}`
  },
  ADD_LICENSE_KEY_TO_ORG: {
    method: 'post',
    url: `${API_BASE_URL}license/v1/{_Id}/{orgId}`
  },
  DELETE_SCHEDULED_KEY: {
    method: 'delete',
    url: `${API_BASE_URL}license/v1/deleteScheduledKey/{_Id}/{orgId}`
  },
  /** Account-level delete for shared allocation (no orgId in path; mirrors ADD_LICENSE_KEY pattern). */
  DELETE_SCHEDULED_KEY_ACCOUNT: {
    method: 'delete',
    url: `${API_BASE_URL}license/v1/deleteScheduledKey/{_Id}`
  },
  GET_RF_PROFILE_DEVICE: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/rfProfile/devices/{_Id}/{orgId}/{networkId}/{profileId}`
  },
  DELETE_RF_PROFILE: {
    method: 'delete',
    url: `${API_BASE_URL}network/v1/rfProfile/{_Id}/{orgId}/{networkId}/{profileId}`
  },
  BULK_DELETE_RF_PROFILE: {
    method: 'delete',
    url: `${API_BASE_URL}wireless/v2/rfProfile/{_Id}/{orgId}/{networkId}`
  },
  CREATE_RF_PROFILE: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/rfProfile/{_Id}/{orgId}/{networkId}`
  },
  UPDATE_RF_PROFILE: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/rfProfile/{_Id}/{orgId}/{networkId}/{profileId}`
  },
  GET_RADIO_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/rfProfile/radioSettings/{_Id}/{orgId}/{networkId}/{profileId}`
  },
  SET_RF_RADIO_SETTING: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/rfProfile/radioSettings/{_Id}/{orgId}/{networkId}/{profileId}`
  },
  GET_INSTANT_WIFI_PREFERRED_CHANNEL: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/rfProfile/instantWifiPreferredChannel/{networkId}/{_Id}/{profileId}/{orgId}`
  },
  SET_INSTANT_WIFI_AUTO_RF_STATUS: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/rfProfile/instantWiFiConfig/{requestType}/{_Id}/{networkId}/{profileId}/{orgId}`
  },
  SET_INSTANT_WIFI_CHANNEL_LIST: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/rfProfile/instantWiFiConfig/selectchannels/{_Id}/{networkId}/{profileId}/{orgId}`
  },
  OPTIMIZE_NOW_INSTANT_WIFI: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/runNowAutoRf/optimize/{_Id}/{networkId}/{profileId}/{orgId}`
  },
  ASSIGNED_RF_PROFILE_TO_DEVICE: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/{firstDynamicParameter}/{_Id}/{orgId}/{networkId}/{secondDynamicParameter}`
  },
  UNASSIGNED_RF_PROFILE_TO_DEVICE: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/unAssignrfProfile/{_Id}/{orgId}/{networkId}`
  },
  GET_CLIENTS_NEIGHBOR_INFO: {
    method: 'get',
    url: `${API_BASE_URL}monitoring/v1/clients/{networkId}/neighbourInfo/{_Id}`
  },
  GET_DEVICE_GROUP_DEVICE_DETAILS: {
    method: 'put',
    url: `${API_BASE_URL}device/v1/deviceList/{_Id}/{networkId}/{page}/{groupId}{searchText}`
  },
  ADD_DEVICE_ROLE_WITH_GROUP: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/{_Id}/{Organization_Id}/{networkId}/group/{xgroupId}`
  },
  GET_WIRED_TRAFFIC_POLICIES: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/{_Id}/{orgId}/{networkId}/wirelessSetting/trafficPolicy/{pageNo}`
  },
  SET_TRAFFIC_POLICY_DETAILS: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/config/{_Id}/{orgId}/{networkId}/{pageNo}/wirelessSetting/trafficPolicy`
  },
  SET_MAC_IP_TRAFFIC_POLICIES: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/config/{_Id}/{orgId}/{networkId}/{pageNo}/trafficPolicy/macIpACL`
  },
  ADD_ORG_WIDE_SSID: {
    method: 'post',
    url: `${API_BASE_URL}wireless/v1/addSsid/{_Id}/{orgId}`
  },
  GET_ORG_NETWORK_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/networkList/{_Id}/{orgId}`
  },
  UPDATE_ORG_WIDE_SSID_DETAILS: {
    method: 'post',
    url: `${API_BASE_URL}wireless/v1/updateSsid/{_Id}/{orgId}/{wirelessOrgId}`
  },
  GET_ORG_WIDE_SSID_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/wirelessorginfo/{_Id}/{orgId}/{wirelessOrgId}`
  },
  ORG_WIDE_SSID_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/orgssidconfig/{_Id}/{orgId}`
  },
  GET_SSID_INFO_DEVICE_GROUP: {
    method: 'get',
    url: `${API_BASE_URL}network/v4/config/{networkId}/wirelessNetwork/{_Id}/{groupId}`
  },
  ADD_DEVICE_GROUP_SSID: {
    method: 'post',
    url: `${API_BASE_URL}wireless/v1/addSsid/{_Id}/{networkId}/{groupId}`
  },
  GET_PAR_SSID_INFO_DEVICE_GROUP: {
    method: 'get',
    url: `${API_BASE_URL}network/v4/config/{networkId}/wirelessNetwork/{wirelessNetworkId}/{orgId}/{_Id}/{groupId}`
  },
  EDIT_DEVICE_GROUP_SSID: {
    method: 'post',
    url: `${API_BASE_URL}wireless/v1/updateSsid/{_Id}/{orgId}/{networkId}/{groupId}/{wirelessNetworkId}`
  },
  GET_CHANNEL_UTILIZATION: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/channelUtil/{serialNo}/{days}/{_Id}`
  },
  GET_AP_THROUGHPUT: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/apThroughput/{serialNo}/{days}/{_Id}`
  },
  // Switch Static Route API Endpoints
  GET_SWITCH_STATIC_ROUTES: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/config/{networkId}/routeInfo/{_Id}`
  },
  ADD_SWITCH_STATIC_ROUTE: {
    method: 'put',
    url: `${API_BASE_URL}network/v2/config/{networkId}/staticRoute/{_Id}`
  },
  DELETE_MULTIPLE_SWITCH_STATIC_ROUTE: {
    method: 'delete',
    url: `${API_BASE_URL}network/v1/config/{networkId}/deleteMultipleStaticRoute/{_Id}`
  },
  // Schema-driven switch config (Full-Configurability) read endpoints. Applies go to DevCom
  // (SAVE_DEVICE_CONFIGURATION), which stores the configuration at once.
  GET_SWITCH_SCHEMA_CATALOG: {
    method: 'get',
    url: `${API_BASE_URL}sw/v1/config/{serialNo}/{userId}/schema`
  },
  GET_SWITCH_SCHEMA_CONFIG: {
    method: 'get',
    url: `${API_BASE_URL}sw/v1/config/{serialNo}/{userId}/schema/{schemaName}`
  },
  // Read-only monitoring/statistics: switchConfiguration.<section>.<schemaName>, section = statistics | status.
  GET_SWITCH_MONITOR_BUCKET: {
    method: 'get',
    url: `${API_BASE_URL}sw/v1/config/{serialNo}/{userId}/monitor/{section}/{schemaName}`
  },
  GET_SWITCH_MONITOR_SECTION: {
    method: 'get',
    url: `${API_BASE_URL}sw/v1/config/{serialNo}/{userId}/monitor/{section}`
  },
  // Ookla Speedtest API Endpoints
  GET_OOKLA_SPEEDTEST: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/speedtest/{_Id}/{orgId}/{networkId}/{deviceId}`
  },
  START_OOKLA_SPEEDTEST: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/troubleshoot/{_Id}/{orgId}/{networkId}`
  },
  // An AP's recorded speed test runs, newest first, 10 per page; page is 1-based
  GET_AP_SPEEDTEST_HISTORY: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/speedtestHistory/{_Id}/{orgId}/{networkId}/{serialNo}/{page}`
  },
  GET_DEVICE_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/devicestatus/{_Id}/{networkId}/{deviceId}/{orgId}`
  },
  GET_CLIENT_LIST_DEVICE_LEVEL: {
    method: 'post',
    url: `${API_BASE_URL}client/v3/{_Id}/{orgId}/{networkId}/{serialNo}/{isConnected}/{page}{searchText}`
  },
  // Never called by a screen: useApi serves GET_CLIENT_LIST_DEVICE_LEVEL from here while the web flag is on.
  GET_CLIENT_LIST_DEVICE_LEVEL_NEW_APPCOM: {
    method: 'get',
    url: `${APPCOM_BASE_URL}v1/networks/{networkId}/devices/{serialNo}/clients`
  },
  GET_STATIC_CLIENT_LIST_DEVICE_LEVEL: {
    method: 'put',
    url: `${API_BASE_URL}client/v1/{_Id}/{orgId}/{networkId}/{serialNo}/1/2/{page}{searchText}`
  },
  GET_PR_CLIENT_LIST_DEVICE: {
    method: 'put',
    url: `${API_BASE_URL}client/v1/{_Id}/{orgId}/{networkId}/{serialNo}/1/{connStatus}/{page}{searchText}`
  },
  GET_PR_CLIENT_LIST_DEVICE_PREMIUM: {
    method: 'put',
    url: `${API_BASE_URL}client/v1/{_Id}/{networkId}/{serialNo}/1/{connStatus}/{page}{searchText}`
  },
  GET_PR_CLIENTS_COUNT_DEVICE: {
    method: 'get',
    url: `${API_BASE_URL}client/v1/count/{_Id}/{orgId}/{networkId}/{serialNo}/all`
  },
  GET_PR_CLIENTS_COUNT_DEVICE_PREMIUM: {
    method: 'get',
    url: `${API_BASE_URL}client/v1/count/{_Id}/{networkId}/{serialNo}/all`
  },
  SET_STATIC_CLIENT_DEVICE_LEVEL: {
    method: 'post',
    url: `${API_BASE_URL}pr/v3/ipReserveDevice/{deviceId}/{_Id}/ipResrvRule/{orgId}`
  },
  DOWNLOAD_STATIC_CLIENT_CSV_DEVICE_LEVEL: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/clientList/download/excel/{deviceId}/{_Id}`
  },
  ONBOARD_STATIC_CLIENTS_DEVICE_LEVEL: {
    method: 'post',
    url: `${API_BASE_URL}pr/v3/ipReserveDevice/{deviceId}/{_Id}/ipResrvRule/{dryRun}/{orgId}`
  },
  ADD_ORG_WIDE_RADIUS_VALUE: {
    method: 'get',
    url: `${API_BASE_URL}organization/v2/{_Id}/{orgId}/radiusServerConfig`
  },
  EDIT_ORG_WIDE_RADIUS_VALUE: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/{_Id}/{orgId}/{wirelessOrgId}/radiusServerConfig`
  },
  GET_VLAN_ROUTING: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/intervlan/{_Id}/{orgId}/{deviceId}`
  },
  SET_VLAN_ROUTING: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/vlanRouting/{_Id}/{orgId}/{deviceId}`
  },
  GET_MESH_INFO_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/getMeshInfoDetails/{deviceId}/{networkId}/{_Id}`
  },
  // Advanced Mesh Configuration API Endpoints
  GET_MESH_ADVANCED_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/meshAdvConfig/{deviceId}/{_Id}`
  },
  POST_MESH_ADVANCED_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/meshAdvConfig/{deviceId}/{_Id}`
  },
  GET_UNCLAIMED_DEVICE_LIST: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/discoverSatellite/nwDevices/{_Id}`
  },
  RAPID_MONITORING: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/rapidMonitoring/{_Id}`
  },
  // PR WAN IP Settings API Endpoints
  GET_PR_WAN_IP_DATA: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/config/{selectedDeviceId}/PR/deviceWANIPSettings/{_Id}`
  },
  SAVE_PR_WAN_IP_DATA: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/config/{selectedDeviceId}/PR/deviceWANIPSettings/{_Id}/{organization_Id}`
  },
  GET_PR_DUAL_WAN_IP_DATA: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/dualWanInfo/{_Id}/{selectedDeviceId}`
  },
  SAVE_PR_DUAL_WAN_IP_DATA: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/dualWan/{_Id}/{selectedDeviceId}/{organization_Id}`
  },
  GET_PR_DUAL_WAN_IPV6_DATA: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/dualWanIpv6Info/{_Id}/{selectedDeviceId}`
  },
  SAVE_PR_DUAL_WAN_IPV6_DATA: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/dualWanIpv6/{_Id}/{selectedDeviceId}/{organization_Id}`
  },
  GET_PR_DUAL_WAN_IPV6_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/dualWanIpv6Status/{_Id}/{selectedDeviceId}`
  },
  // R07a S5: latest-packet WAN / VLAN / dual-WAN status snapshot (read-only; R07b reuses it).
  GET_PR_STATUS_SNAPSHOT: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/statusSnapshot/{_Id}/{selectedDeviceId}`
  },
  // R07d: the four VPN status keys of the latest packet (read-only; VPN Status tab, Summary card,
  // S2S tab status column). BE "[ProRouterController] getPrVpnStatus".
  GET_PR_VPN_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/vpnStatus/{_Id}/{selectedDeviceId}`
  },
  // R07e: LLDP neighbours, LAN / WAN port stats and wired throughput of the latest packet (read-only;
  // LLDP page, Summary port status table and Port Statistics card). BE "[ProRouterController] getPrPortStatus".
  GET_PR_PORT_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/portStatus/{_Id}/{selectedDeviceId}`
  },
  SET_VLAN_IDS_LIST: {
    method: 'put',
    url: `${API_BASE_URL}device/v1/vlanMembers/{selectedDeviceId}/{_Id}`
  },
  SAVE_SWITCH_PORT_CONFIG: {
    method: 'put',
    url: `${API_BASE_URL}network/v2/config/{networkId}/device/portConfig/{_Id}`,
    // 3 minutes, not the 60s default. The standalone path sends up to 3 sequential device
    // commands (portConfig + PoE + authMode), each a synchronous xCloud round-trip that waits
    // for the physical switch to respond — 3 calls at 40-50s each exceed the default and abort
    // client-side while the server is still finishing, showing "failed" for a save that succeeded.
    // Same rationale as DELETE_STACK (180s).
    timeout: 180000
  },
  GET_ALWAYS_ACTIVE_PORT: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/activePortInfo/{_Id}/{organization_Id}/{networkId}`
  },
  SET_ALWAYS_ACTIVE_PORT: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/activePort/{_Id}/{organization_Id}/{networkId}`
  },
  GET_SWITCH_PORT_SETTING: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/switchGroupPortInfo/{serialNo}/{portNo}/{_Id}`
  },
  GET_POE_SCHEDULES: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/schedulers/{networkId}/{_Id}`
  },
  SAVE_POE_SCHEDULE: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/config/{networkId}/poeScheduler/{_Id}`
  },
  UPDATE_POE_SCHEDULE_STATUS: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/config/{networkId}/{scheduleId}/poeSchedulerMode/{_Id}`
  },
  UPDATE_POE_SCHEDULE_DETAILS: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/{scheduleId}/update/{_Id}`
  },
  UPDATE_POE_SCHEDULE_PORTS: {
    method: 'put',
    url: `${API_BASE_URL}network/v1/applyPoeScheduler/{networkId}/{scheduleId}/{_Id}`
  },
  DELETE_POE_SCHEDULE: {
    method: 'delete',
    url: `${API_BASE_URL}network/v1/delete/{scheduleId}/{_Id}`
  },
  GET_PROTECTED_PORT: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/protectedPort/{_Id}/{organization_Id}/{networkId}`
  },
  SET_PROTECTED_PORT: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/protectedPort/{_Id}/{organization_Id}/{networkId}`
  },
  // Dynamic DNS API Endpoints
  GET_DDNS_LIST: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getDdns/{_Id}/{deviceId}`
  },
  GET_DDNS_DETAIL: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getDdns/{_Id}/{deviceId}/{ddnsId}`
  },
  GET_DDNS_PROVIDERS: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/ruleDetails/{deviceId}/{_Id}`
  },
  CREATE_OR_UPDATE_DDNS: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/ddns/{_Id}/{deviceId}/{commandType}/{orgId}`
  },
  DELETE_DDNS_PROFILE: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v2/deleteDdns/{_Id}/{deviceId}/{orgId}`
  },
  // Neighboring Access Points API Endpoints
  GET_KNOWN_UNKNOWN_APS: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/knownunknownaps/{networkId}/{deviceId}/{_Id}`
  },
  GET_RF_CHANNEL: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/rfChannel/{networkId}/{serialNo}/{_Id}`
  },
  // Pro Router Port Forwarding API Endpoints
  GET_PR_PORT_FORWARDING: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getPortForwarding/{_Id}/{deviceId}`
  },
  SET_PR_PORT_FORWARDING: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/setPortForwarding/{_Id}/{deviceId}/{commandType}/{orgId}`
  },
  GET_PR_OPENVPN_INFO: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/opnVpnInfo/{deviceId}/{_Id}`
  },
  // Dual WAN Rules API Endpoints
  GET_PR_DUAL_WAN_RULES: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getDualWanRules/{_Id}/{selectedDeviceId}`
  },
  // {commandType} = createRule | updateRule (PRDualWANRules.jsx), same as the IPv6 twin below.
  CREATE_PR_DUAL_WAN_RULE: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/dualWanRules/{_Id}/{organization_Id}/{selectedDeviceId}/{commandType}`
  },
  DELETE_PR_DUAL_WAN_RULES: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v1/deleteWanRule/{_Id}/{organization_Id}/{selectedDeviceId}`
  },
  UPDATE_PR_DUAL_WAN_RULE_PRIORITY: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/dualWanPriorityRule/{_Id}/{organization_Id}/{selectedDeviceId}`
  },
  GET_PR_DUAL_WAN_IPV6_RULES: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getDualWanIpv6Rules/{_Id}/{selectedDeviceId}`
  },
  CREATE_PR_DUAL_WAN_IPV6_RULE: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/dualWanIpv6Rules/{_Id}/{organization_Id}/{selectedDeviceId}/{commandType}`
  },
  DELETE_PR_DUAL_WAN_IPV6_RULES: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v1/deleteWanIpv6Rule/{_Id}/{organization_Id}/{selectedDeviceId}`
  },
  UPDATE_PR_DUAL_WAN_IPV6_RULE_PRIORITY: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/dualWanIpv6RulePriority/{_Id}/{organization_Id}/{selectedDeviceId}`
  },
  // R08 NPT / Netmap rules, cmds 10167-10169 (Confluence page 1986625792; feature doc 6.3).
  // commandType: createRule (10167, netmapRules array) / updateRule (10168, one object).
  GET_PR_NETMAP_RULES: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getNetmapRules/{_Id}/{selectedDeviceId}`
  },
  SET_PR_NETMAP_RULE: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/netmapRules/{_Id}/{organization_Id}/{selectedDeviceId}/{commandType}`
  },
  DELETE_PR_NETMAP_RULES: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v1/deleteNetmapRules/{_Id}/{organization_Id}/{selectedDeviceId}`
  },
  // R15 UPnP, cmd 10046 (Confluence page 2047869012 Batch C; feature doc 3.2, 6.3).
  // The device endpoint URI is under Q-P3-23; these are the Insight routes, which are settled.
  GET_PR_UPNP_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getUpnpSettings/{_Id}/{selectedDeviceId}`
  },
  SET_PR_UPNP_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/upnpSettings/{_Id}/{organization_Id}/{selectedDeviceId}`
  },
  // Dynamic DNS > Advanced Settings, cmd 10123 (Confluence page 1767243823, section AdvancedDDNS).
  // Same route shape as UPnP.
  GET_PR_DDNS_ADVANCED_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getDdnsAdvancedSettings/{_Id}/{selectedDeviceId}`
  },
  SET_PR_DDNS_ADVANCED_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/ddnsAdvancedSettings/{_Id}/{organization_Id}/{selectedDeviceId}`
  },
  // R15 LAG (cmd 10122) and port settings (cmd 10056). Same route shape as UPnP: the GET has no
  // organization segment, the POST does.
  GET_PR_LAG_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getLagSettings/{_Id}/{selectedDeviceId}`
  },
  SET_PR_LAG_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/lagSettings/{_Id}/{organization_Id}/{selectedDeviceId}`
  },
  GET_PR_PORT_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getPortSettings/{_Id}/{selectedDeviceId}`
  },
  SET_PR_PORT_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/portSettings/{_Id}/{organization_Id}/{selectedDeviceId}`
  },
  GET_PR_RULE_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/ruleDetails/{selectedDeviceId}/{_Id}`
  },
  UPDATE_MHS_PROFILE: {
    method: 'put',
    url: `${preEnvUrl}profile/v1/config/{_Id}/{orgId}/{profileId}/{commandType}`
  },
  SHOW_SUPPORT_REQUEST_LIST: {
    method: 'get',
    url: `${API_BASE_URL}supportuser/v2/supportuseraccessslist/{_Id}/{page}{searchText}`
  },
  START_SUPPORT_SESSION: {
    method: 'put',
    url: `${API_BASE_URL}supportuser/v1/supportsession/{_Id}`
  },
  GET_SUPPORT_SESSION_ACTIVITY: {
    method: 'get',
    url: `${API_BASE_URL}supportuser/v1/sessionactivity/{_Id}`
  },
  CONTINUE_SUPPORT_SESSION: {
    method: 'put',
    url: `${API_BASE_URL}supportuser/v1/continuesession/{_Id}`
  },
  // Impersonation hand-over: read-only poll (does not refresh the inactivity timer) and the
  // active agent's Allow / Deny decision on a pending request.
  GET_IMPERSONATION_REQUEST_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}supportuser/v1/impersonationstatus/{_Id}`
  },
  DECIDE_IMPERSONATION_REQUEST: {
    method: 'put',
    url: `${API_BASE_URL}supportuser/v1/impersonationdecision/{_Id}`
  },
  GRANT_SUPPORT_ACCESS: {
    method: 'put',
    url: `${API_BASE_URL}supportuser/v1/supportaccess/{_Id}`
  },
  END_SUPPORT_ACCESS: {
    method: 'put',
    url: `${API_BASE_URL}supportuser/v1/supportaccess/{_Id}`
  },
  // Port Filtering API Endpoints
  GET_MHS_PORT_FILTERING: {
    method: 'get',
    url: `${preEnvUrl}profile/v1/portFiltering/{_Id}/{orgId}/{profileId}`
  },
  UPDATE_MHS_PORT_FILTERING: {
    method: 'put',
    url: `${preEnvUrl}profile/v1/portFiltering/{_Id}/{orgId}/{profileId}`
  },
  // SASE Device API - Check Partner Org Gateway Subnet Conflict
  CHECK_PARTNER_ORG_GATEWAY_SUBNET_CONFLICT: {
    method: 'post',
    url: `${API_BASE_URL}saseDevice/v1/checkPartnerOrgGatewaySubnetConflict/{_Id}/{networkId}`
  },
  DELETE_STATIC_CLIENT_DEVICE_LEVEL: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v2/deleteIpReservation/{_Id}/{deviceId}/{orgId}`
  },
  // ==============================|| Certificate Authority API Endpoints ||============================== //
  // GET Certificate Authority List
  GET_AUTH_CERTIFICATE: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/authCert/{selectedDeviceId}/{_Id}`
  },
  // POST - Add/Save Certificate Authority
  SET_AUTH_CERTIFICATE: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/authCert/{selectedDeviceId}/{_Id}/{organization_Id}`
  },
  // DELETE Certificate Authority
  DELETE_AUTH_CERTIFICATE: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v2/deleteCert/{selectedDeviceId}/{_Id}/{certType}/{organization_Id}`
  },
  // POST - Renew Certificate Authority
  RENEW_AUTH_CERTIFICATE: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/authCertRenew/{selectedDeviceId}/{_Id}/{organization_Id}`
  },
  // POST - Export Certificate Data (cert or private key)
  EXPORT_CERTIFICATE_DATA: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/exportCert/{selectedDeviceId}/{_Id}/{exportType}/{organization_Id}`
  },
  // POST - Import Certificate
  IMPORT_CERTIFICATE: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/importCert/{selectedDeviceId}/{_Id}/{organization_Id}`
  },
  // POST - View Certificate Details (initiates certificate details request)
  VIEW_CERTIFICATE_DETAILS: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/certDetails/{selectedDeviceId}/{_Id}/{organization_Id}`
  },
  // GET - Fetch Certificate Details (retrieves the actual certificate content)
  GET_CERTIFICATE_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/certDetails/{selectedDeviceId}/{_Id}`
  },
  // ==============================|| Server Certificate API Endpoints ||============================== //
  // POST - Create Server Certificate
  SET_SERVER_CERTIFICATE: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/createCert/{selectedDeviceId}/{_Id}/serverCert/{organization_Id}`
  },
  // ==============================|| QoS (Quality of Service) API Endpoints ||============================== //
  // GET QoS Configuration
  GET_PR_QOS_CONFIG: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getQosConfig/{_Id}/{selectedDeviceId}`
  },
  // GET QoS Speed Test Status
  GET_PR_QOS_SPEED_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getQosSpeed/{_Id}/{selectedDeviceId}`
  },
  // POST - Save QoS Configuration
  SAVE_PR_QOS_CONFIG: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/setQosConfig/{_Id}/{selectedDeviceId}/{organization_Id}`
  },
  // POST - Start QoS Speed Test
  START_PR_QOS_SPEED_TEST: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/qosSpeedTest/{_Id}/{selectedDeviceId}/{organization_Id}`
  },
  // ==============================|| PR Static Route API Endpoints ||============================== //
  // GET PR Static Routes List
  // URL format: pr/v1/getStaticRoute/{_Id}/{selectedDeviceId}/all?searchText=
  GET_PR_STATIC_ROUTES: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getStaticRoute/{_Id}/{selectedDeviceId}/all`
  },
  // POST - Create PR Static Route
  CREATE_PR_STATIC_ROUTE: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/setStaticRoute/{_Id}/{selectedDeviceId}/createStaticRoute/{organization_Id}`
  },
  // POST - Update PR Static Route
  UPDATE_PR_STATIC_ROUTE: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/setStaticRoute/{_Id}/{selectedDeviceId}/updateStaticRoute/{organization_Id}`
  },
  // DELETE - Delete PR Static Routes
  DELETE_PR_STATIC_ROUTES: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v2/deleteStaticRoute/{_Id}/{selectedDeviceId}/deleteStaticRoute/{organization_Id}`
  },
  // ==============================|| PR RIP (Routing Information Protocol) API Endpoints ||============================== //
  // GET PR RIP Configuration
  GET_PR_RIP_CONFIG: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getRipConfig/{_Id}/{selectedDeviceId}`
  },
  // POST - Save PR RIP Configuration
  SAVE_PR_RIP_CONFIG: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/setRipConfig/{_Id}/{selectedDeviceId}/{organization_Id}`
  },
  // DHCP Relay API Endpoints
  GET_DHCP_RELAY_GLOBAL_PORT_CONFIG: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/dhcpRelay/{_Id}/{organization_Id}/{currentNetwork}/globalportconfig`
  },
  SET_DHCP_RELAY_GLOBAL_CONFIG: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/dhcpRelay/{_Id}/{organization_Id}/{currentNetwork}/globalconfig`
  },
  SET_DHCP_RELAY_PORT_CONFIG: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/dhcpRelay/{_Id}/{organization_Id}/{currentNetwork}/portconfig`
  },
  // DHCP Snooping APIs
  GET_DHCP_SNOOPING_GLOBAL_PORT_CONFIG: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/dhcpSnooping/{_Id}/{organization_Id}/{currentNetwork}/globalportconfig`
  },
  SET_DHCP_SNOOPING_GLOBAL_CONFIG: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/dhcpSnooping/{_Id}/{organization_Id}/{currentNetwork}/globalconfig`
  },
  SET_DHCP_SNOOPING_PORT_CONFIG: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/dhcpSnooping/{_Id}/{organization_Id}/{currentNetwork}/portconfig`
  },
  // ==============================|| VPN - OpenVPN API Endpoints ||============================== //
  GET_PR_OPENVPN_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/openVpn/{deviceId}/{_Id}`
  },
  SET_PR_OPENVPN_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/setOpenVpn/{deviceId}/{_Id}/{commandType}/{organization_Id}`
  },
  EXPORT_PR_OPENVPN_CONFIG: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/expOpenVpn/{deviceId}/{_Id}/{organization_Id}`
  },
  // ==============================|| VPN - IPSec Site-to-Site API Endpoints ||============================== //
  GET_IPSEC_SITE_TO_SITE_LIST: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/getIpSecSite/{deviceId}/{_Id}`
  },
  GET_IPSEC_SITE_TO_SITE_DETAIL: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/getIpSecSite/{deviceId}/{_Id}/{connectionName}`
  },
  SET_IPSEC_SITE_TO_SITE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/setIpSecSite/{deviceId}/{_Id}/{commandType}/{organization_Id}`
  },
  DELETE_IPSEC_SITE_TO_SITE: {
    method: 'delete',
    url: `${API_BASE_URL}device/v1/deleteIpSecSite/{deviceId}/{_Id}/{organization_Id}`
  },
  IPSEC_LINK: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/ipSecLink/{_Id}/{deviceId}/{organization_Id}`
  },
  // ==============================|| VPN - IPSec Profiles API Endpoints ||============================== //
  GET_IPSEC_PROFILES_LIST: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/ipSecProfiles/{deviceId}/{_Id}`
  },
  GET_IPSEC_PROFILE_DETAIL: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/ipSecProfiles/{deviceId}/{_Id}/{profileName}`
  },
  SET_IPSEC_PROFILE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/ipSecProfile/{deviceId}/{_Id}/{commandType}/{organization_Id}`
  },
  DELETE_IPSEC_PROFILE: {
    method: 'delete',
    url: `${API_BASE_URL}device/v1/ipSecProfile/{deviceId}/{_Id}/{organization_Id}`
  },
  // ==============================|| VPN - IPSec Client-to-Site API Endpoints ||============================== //
  GET_IPSEC_CLIENT_TO_SITE_LIST: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/clientToSite/{deviceId}/{_Id}`
  },
  GET_IPSEC_CLIENT_TO_SITE_DETAIL: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/clientToSite/{deviceId}/{_Id}/{tunnelName}`
  },
  SET_IPSEC_CLIENT_TO_SITE: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/clientToSite/{deviceId}/{_Id}/{commandType}/{organization_Id}`
  },
  DELETE_IPSEC_CLIENT_TO_SITE: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v2/clientToSite/{deviceId}/{_Id}/{organization_Id}`
  },
  // ==============================|| VPN - VPN Users API Endpoints ||============================== //
  GET_VPN_USERS_LIST: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/vpnUsers/{deviceId}/{_Id}`
  },
  SET_VPN_USER: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/vpnUser/{deviceId}/{_Id}/{commandType}/{organization_Id}`
  },
  DELETE_VPN_USER: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v2/delVpnUsers/{deviceId}/{_Id}/{organization_Id}`
  },
  // ==============================|| VPN - WireGuard API Endpoints ||============================== //
  GET_WIREGUARD_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/wireguardSettings/{deviceId}/{_Id}`
  },
  SET_WIREGUARD_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/confWireguard/{deviceId}/{_Id}/{organization_Id}`
  },
  GENERATE_WIREGUARD_KEYS: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/exportWireKeys/{deviceId}/{_Id}`
  },
  FETCH_WIREGUARD_KEYS: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/fetchWireKeys/{deviceId}/{_Id}`
  },
  // ==============================|| VPN - WireGuard Clients API Endpoints ||============================== //
  GET_WIREGUARD_CLIENTS_LIST: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/wireguardClient/{_Id}/{deviceId}`
  },
  GET_WIREGUARD_CLIENT_DETAIL: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/wireguardClient/{_Id}/{deviceId}/{clientName}`
  },
  SET_WIREGUARD_CLIENT: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/confWireguardClient/{_Id}/{organization_Id}/{deviceId}/{commandType}`
  },
  DELETE_WIREGUARD_CLIENT: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v1/deleteWireguardClient/{_Id}/{organization_Id}/{deviceId}`
  },
  EXPORT_WIREGUARD_CLIENT: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/exportWireguardClient/{_Id}/{deviceId}/{exportType}`
  },
  GET_WIREGUARD_CLIENT_QR: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/wgClientConfig/{_Id}/{deviceId}/{clientName}`
  },
  // ==============================|| Security - Firewall Basic Settings API Endpoints ||============================== //
  GET_FIREWALL_BASIC_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/basicSettings/{deviceId}/{_Id}`
  },
  SET_FIREWALL_BASIC_SETTINGS: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/basicSettings/{deviceId}/{_Id}/{organization_Id}`
  },
  // ==============================|| Security - Traffic Rules API Endpoints ||============================== //
  GET_TRAFFIC_RULES_LIST: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/trafficRules/{deviceId}/{_Id}`
  },
  GET_TRAFFIC_RULE_DETAIL: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/trafficRules/{deviceId}/{_Id}/{ruleName}`
  },
  SET_TRAFFIC_RULE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/trafficRules/{deviceId}/{_Id}/{commandType}/{organization_Id}`
  },
  DELETE_TRAFFIC_RULES: {
    method: 'delete',
    url: `${API_BASE_URL}device/v1/trafficRules/{deviceId}/{_Id}/{organization_Id}`
  },
  // ==============================|| Security - Firewall Schedule API Endpoints ||============================== //
  GET_FIREWALL_SCHEDULE_LIST: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/firewallSch/{deviceId}/{_Id}`
  },
  GET_FIREWALL_SCHEDULE_DETAIL: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/firewallSch/{deviceId}/{_Id}/{scheduleName}`
  },
  SET_FIREWALL_SCHEDULE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/firewallSch/{deviceId}/{_Id}/{commandType}/{organization_Id}`
  },
  DELETE_FIREWALL_SCHEDULE: {
    method: 'delete',
    url: `${API_BASE_URL}device/v1/firewallSch/{deviceId}/{_Id}/{organization_Id}`
  },
  // ==============================|| Security - Outbound NAT API Endpoints ||============================== //
  GET_OUTBOUND_NAT_LIST: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getNatRules/{_Id}/{deviceId}`
  },
  GET_OUTBOUND_NAT_DETAIL: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getNatRules/{_Id}/{deviceId}/{ruleName}`
  },
  SET_OUTBOUND_NAT: {
    method: 'post',
    url: `${API_BASE_URL}pr/v1/confNatRule/{_Id}/{organization_Id}/{deviceId}/{commandType}`
  },
  DELETE_OUTBOUND_NAT: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v1/deleteNatRule/{_Id}/{organization_Id}/{deviceId}`
  },
  // ==============================|| Security - Port Triggering API Endpoints ||============================== //
  GET_PORT_TRIGGERING_LIST: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getPortTriggering/{_Id}/{deviceId}`
  },
  GET_PORT_TRIGGERING_DETAIL: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getPortTriggering/{_Id}/{deviceId}/{portTrgId}`
  },
  SET_PORT_TRIGGERING: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/setPortTriggering/{_Id}/{deviceId}/{commandType}/{organization_Id}`
  },
  // ==============================|| Security - Service Management API Endpoints ||============================== //
  GET_SERVICE_MANAGEMENT_LIST: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getServiceManagement/{deviceId}/{_Id}`
  },
  GET_SERVICE_MANAGEMENT_DETAIL: {
    method: 'get',
    url: `${API_BASE_URL}pr/v1/getServiceManagement/{deviceId}/{_Id}/{serviceName}`
  },
  SET_SERVICE_MANAGEMENT: {
    method: 'post',
    url: `${API_BASE_URL}pr/v2/serviceManagement/{deviceId}/{_Id}/{commandType}/{organization_Id}`
  },
  DELETE_SERVICE_MANAGEMENT: {
    method: 'delete',
    url: `${API_BASE_URL}pr/v2/deleteServiceManagement/{deviceId}/{_Id}/{organization_Id}`
  },
  // ==============================|| Supporting API Endpoints ||============================== //
  GET_IPSEC_PROPOSAL_LIST: {
    method: 'get',
    url: `${API_BASE_URL}public/v1/ipseclist`
  },

  // ==============================|| ORBI API Endpoints ||============================== //
  GET_ORBI_SUMMARY: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/deviceInfo/{selectedDeviceId}/ORBI/dashboard/{_Id}`
  },
  GET_ORBI_CLIENT_COUNT: {
    method: 'get',
    url: `${API_BASE_URL}client/v1/count/{_Id}/{orgId}/{networkId}/{serialNo}/all`
  },
  GET_ORBI_CLIENT_LIST: {
    method: 'put',
    url: `${API_BASE_URL}client/v1/{_Id}/{orgId}/{networkId}/{serialNo}/{pageNo}/{isConnected}/{connectionType}?searchText={searchText}`
  },
  GET_ORBI_SATELLITE_LIST: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/satellitelist/{_Id}/{selectedDeviceId}/all`
  },
  // Delete satellite(s) — v2 bulk: DELETE device/v2/deleteSatellites/{accountId}/{routerSerial}
  // Body: string[] of satellite MAC addresses (single delete uses a one-element array)
  DELETE_SATELLITES: {
    method: 'delete',
    url: `${API_BASE_URL}device/v2/deleteSatellites/{_Id}/{selectedDeviceSerial}`
  },
  // Satellite pairing-progress poll used by the guided Add Satellite wizard. Same
  // backend as legacy portal (imuserportal Api.js: "getSatellite" ->
  // device/v2/satellitestatus/<deviceId>/<_Id>). Response: { info: [{ status }] }
  // where status "0" = added, "1" = pairing, "2" = failed.
  GET_ORBI_SATELLITE_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/satellitestatus/{selectedDeviceId}/{_Id}`
  },
  // Add (claim) a satellite to an Orbi router. Same backend as legacy portal
  // (imuserportal Api.js: "device/v1/addsatellite/" + _Id). Body: { deviceInfo: { serialNo } }
  ADD_SATELLITE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/addsatellite/{_Id}`
  },
  // Outdoor Satellites table = wireless neighbor scan (known/unknown APs), same
  // backend as legacy portal (imuserportal Api.js: device/v2/knownunknownaps/...)
  GET_ORBI_OUTDOOR_SATELLITES: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/knownunknownaps/{networkId}/{selectedDeviceId}/{_Id}`
  },
  GET_ORBI_TRAFFIC_DATA: {
    method: 'get',
    url: `${API_BASE_URL}orbi/v1/trafficData/{_Id}/{selectedDeviceId}/{timeRange}`
  },
  GET_ORBI_LAN_IP: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/config/{selectedDeviceId}/ORBI/deviceLANIPSettings/{_Id}`
  },
  SET_ORBI_LAN_IP: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/config/{selectedDeviceId}/ORBI/deviceLANIPSettings/{_Id}/{organization_Id}`
  },
  GET_ORBI_WAN_IP: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/config/{selectedDeviceId}/ORBI/deviceWANIPSettings/{_Id}`
  },
  SET_ORBI_WAN_IP: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/config/{selectedDeviceId}/ORBI/deviceWANIPSettings/{_Id}/{organization_Id}`
  },

  SET_ORBI_DEVICE_MODE: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/orbiconfig/{_Id}/{selectedDeviceId}/deviceMode`
  },

  GET_ORBI_VLAN_LIST: {
    method: 'get',
    url: `${API_BASE_URL}orbi/v1/vlannetworklist/{_Id}/{selectedDeviceId}`
  },
  GET_ORBI_NETWORK_SETUP_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}orbi/v1/vlannetworksetting/{_Id}/{selectedDeviceId}/vlan/{vlanId}`
  },
  // Create/Update an ORBI VLAN (network setup). Mirrors legacy "saveVLANdetails" POST
  // orbi/v1/vlanNetworkOverhaulConfig/{_Id}/{selectedDeviceId}/{commandType}
  // where commandType is "createVlan" | "updateVlan".
  SET_ORBI_NETWORK_SETUP_DETAILS: {
    method: 'post',
    url: `${API_BASE_URL}orbi/v1/vlanNetworkOverhaulConfig/{_Id}/{selectedDeviceId}/{commandType}`
  },
  DELETE_ORBI_VLAN: {
    method: 'post',
    url: `${API_BASE_URL}orbi/v1/vlanNetworkOverhaulConfig/{_Id}/{selectedDeviceId}/deleteVlan`
  },

  GET_ORBI_WIFI_NETWORKS: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/wirelessNetwork/{_Id}/{selectedDeviceId}`
  },
  UPDATE_ORBI_WIFI_NETWORK: {
    method: 'put',
    url: `${API_BASE_URL}device/v2/wirelessnetwork/{_Id}/{selectedDeviceId}`
  },
  SET_ORBI_WIFI_NETWORKS: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/orbiconfig/{_Id}/{selectedDeviceId}/deviceWifiDetails`
  },
  GET_ORBI_RADIO_CHANNELS: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/orbi/rfchannel/{networkId}/{selectedDeviceId}/{_Id}`
  },
  SET_ORBI_RADIO_CHANNELS: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/orbi/rfchannel/{networkId}/{selectedDeviceId}/{_Id}`
  },
  GET_ORBI_WIFI_SCHEDULES: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/fetchWifiSchedule/{_Id}/{selectedDeviceId}`
  },
  CREATE_ORBI_WIFI_SCHEDULE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/wifiSchedule/{_Id}/{selectedDeviceId}/createWifiSchedule`
  },
  DELETE_ORBI_WIFI_SCHEDULE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/wifiSchedule/{scheduleId}/{_Id}/{selectedDeviceId}/deleteWifiSchedule`
  },
  GET_ORBI_DHCP_SERVERS: {
    method: 'get',
    url: `${API_BASE_URL}orbi/v1/dhcpconfig/{_Id}/{selectedDeviceId}`
  },
  SET_ORBI_DHCP_SERVER: {
    method: 'post',
    url: `${API_BASE_URL}orbi/v1/dhcpconfig/{_Id}/{selectedDeviceId}/{commandType}`
  },
  DELETE_ORBI_DHCP_SERVER: {
    method: 'post',
    url: `${API_BASE_URL}orbi/v1/dhcpconfig/{_Id}/{selectedDeviceId}/deleteLanSubnet`
  },
  GET_ORBI_STATIC_ROUTES: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/operateStaticRoute/{_Id}/{selectedDeviceId}/getStaticRoute`
  },
  ADD_ORBI_STATIC_ROUTE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/operateStaticRoute/{_Id}/{selectedDeviceId}/createStaticRoute`
  },
  UPDATE_ORBI_STATIC_ROUTE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/operateStaticRoute/{_Id}/{selectedDeviceId}/updateStaticRoute`
  },
  DELETE_ORBI_STATIC_ROUTE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/operateStaticRoute/{_Id}/{selectedDeviceId}/deleteStaticRoute`
  },
  GET_SINGLE_DEVICE_FIRMWARE_LIST: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/fwUpgrade/singleDeviceFwInfo/{serialNo}/{networkId}/{_Id}`
  },
  UPDATE_ORBI_FIRMWARE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/fwUpgrade/1/{selectedDeviceId}/{_Id}`
  },
  GET_ORBI_FIRMWARE_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/devicefwUpdateStatus/2/{networkId}/{_Id}`
  },
  GET_ORBI_CONFIG_BACKUP: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/getbackupinfo/{selectedDeviceId}/{_Id}`
  },
  RESTORE_ORBI_CONFIG: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/restoreconfig/{_Id}`
  },
  ORBI_RMA_RESTORE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/rmadeviceconfigs/{_Id}`
  },
  ORBI_PING_TEST: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/pingtest/{_Id}/{networkId}/{selectedDeviceId}`
  },
  ORBI_DNS_LOOKUP: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/dnstest/{_Id}`
  },
  ORBI_SPEED_TEST: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/speedtest/{_Id}`
  },
  ORBI_TRACEROUTE: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/traceroutetest/{_Id}/{networkId}/{selectedDeviceId}`
  },
  // Copy Configuration: save/clone network config from source to target locations
  SAVE_COPY_CONFIG: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/clonenetwork/{_Id}`
  },
  // Organization-level firmware compatibility check for copy configuration (classic: fwcompatibilty/{userId}/14/3)
  CHECK_COPY_CONFIG_FIRMWARE_COMPATIBILITY: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/fwcompatibilty/{_Id}/14/3`
  },
  /** Cloud REST API tokens (partners / MSP) */
  GET_CLOUD_REST_API_TOKENS: {
    method: 'get',
    url: `${API_BASE_URL}token/v1/restApiTokens`
  },
  POST_CLOUD_REST_API_TOKEN: {
    method: 'post',
    url: `${API_BASE_URL}token/v1/restApiTokens`
  },
  DELETE_CLOUD_REST_API_TOKEN: {
    method: 'delete',
    url: `${API_BASE_URL}token/v1/restApiTokens/{tokenId}`
  },
  // ==============================|| Reports API Endpoints ||============================== //
  // Paginated list of reports for the current user (page is 0-based).
  // PUT body: { sortBy, sortDir, dataFilter: [{ field, operator, value }] }.
  // {searchText} is replaced with "?searchText=<value>" or "" by SmartDataGrid's getParams.
  REPORT_LIST: {
    method: 'put',
    url: `${API_BASE_URL}organization/v2/reportlist/{_Id}/{page}{searchText}`
  },
  // Catalog of widgets (grouped by reportType / dataType) used in the Pick Widgets step
  GET_WIDGET_LIST: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/widgetInfo/all`
  },
  // Org -> Network tree (used in the Filter step to render selectable orgs/locations)
  GET_ORG_NET_DETAILS_LIST: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/filters/{_Id}`
  },
  // Existing saved filters (tags) used in the "Use Existing" filter option
  GET_FILTER_LIST: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/reporttag/{_Id}`
  },
  // Full report template details (used for edit pre-fill)
  GET_REPORT_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/reporttemplate/{_Id}/{reportId}`
  },
  // Validate a report name is unique before saving
  VALIDATE_REPORT_NAME: {
    method: 'post',
    url: `${API_BASE_URL}organization/v1/reportname/{_Id}/`
  },
  // Save a new report template
  SAVE_REPORT: {
    method: 'post',
    url: `${API_BASE_URL}organization/v2/reporttemplate/{_Id}`
  },
  // ===========|| Captive Portal (FCP) reports — wizard → AppCom → insight-job-service ||=========== //
  // SSID-groups tree for the Filter & Scope step (built from AppCom Mongo).
  CAPTIVE_PORTAL_SSID_GROUPS: {
    method: 'get',
    url: `${API_BASE_URL}captive-portal/v2/ssid-groups`
  },
  // Submit a captive-portal report → AppCom forwards to insight-job-service. Returns { jobId }.
  CAPTIVE_PORTAL_SUBMIT_REPORT: {
    method: 'post',
    url: `${API_BASE_URL}captive-portal/v2/reports`
  },
  // Poll job status by jobId.
  CAPTIVE_PORTAL_REPORT_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}captive-portal/v2/reports/{jobId}`
  },
  // Presigned download URL for a completed report.
  CAPTIVE_PORTAL_REPORT_DOWNLOAD: {
    method: 'get',
    url: `${API_BASE_URL}captive-portal/v2/reports/{jobId}/download`
  },
  // Cancel (deactivate) a recurring report schedule → AppCom forwards to
  // insight-job-service DELETE /job-schedules/{scheduleId}. Used on edit of a
  // scheduled CP report so the stale cron from the previous version is removed.
  CAPTIVE_PORTAL_CANCEL_SCHEDULE: {
    method: 'delete',
    url: `${API_BASE_URL}captive-portal/v2/reports/schedules/{scheduleId}`
  },
  // Update an existing report template
  UPDATE_REPORT: {
    method: 'put',
    url: `${API_BASE_URL}organization/v1/reporttemplate/{_Id}/{reportId}`
  },
  // Bulk-delete one or more report templates.
  // Body: array of reportTemplateId strings. Response mirrors the device-list
  // pattern with `details.successDeleted` and `details.notFound` arrays.
  DELETE_REPORT: {
    method: 'delete',
    url: `${API_BASE_URL}organization/v2/reportType/{_Id}`
  },
  // ==============================|| Notification Settings - Global Settings ||============================== //
  GET_NOTI_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}notification/v1/config/{_Id}`
  },
  POST_NOTI_DETAILS: {
    method: 'post',
    url: `${API_BASE_URL}notification/v1/notificationconfig/{_Id}`
  },

  // ==============================|| Notification Settings - Organization Settings ||============================== //
  // GET full per-org / per-location notification preferences (used to populate
  // the org+location tree on the Organization Settings tab). Same legacy
  // endpoint as `getUserSettings` ("network/v1/userSetting/{_Id}").
  GET_USER_NOTI_SETTINGS: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/userSetting/{_Id}`
  },
  // Paginated org/location tree + per-network notification preferences for
  // the Organization Settings tab (`page` is 0-based). Optional `{searchText}`
  // is appended as a path segment: `/userSetting/{_Id}/0/myquery`.
  GET_USER_NOTI_SETTINGS_PAGED: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/userSetting/{_Id}/{page}{searchText}`
  },
  // POST partial update of per-location notification preferences. The legacy
  // backend exposes one endpoint per channel (`push` and `email`) — see
  // `partialUpdateUserSettings` in src_old. `{type}` is interpolated by the
  // useApi hook from the params bag (e.g. { type: 'push' } / { type: 'email' }).
  POST_USER_NOTI_SETTINGS_PARTIAL: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/userSetting/partial/{type}/{_Id}`
  },
  // POST per-org "Sent To Manager" (mngrEmailStatus / mngrPushStatus). `{userId}`
  // is replaced by useApi from cookies (`_Id` / `userid` / `userId`).
  POST_MANAGER_ORG_NOTIFICATION: {
    method: 'put',
    url: `${API_BASE_URL}unified/v1/managerOrgNotification/{userId}`
  },

  // ==============================|| Notification Settings - Event Notifications ||============================== //
  // GET notification feature catalogue + per-feature email/push selection for a
  // given level. The trailing `{level}` segment matches legacy semantics:
  //   "1" -> Account events, "2" -> Organization events,
  //   "3" -> Network events,  "4" -> Device events.
  // Mirrors legacy `getAccNotiDetails` (url: notification/v1/notifications/{_Id}/{level}).
  GET_ACC_NOTI_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}notification/v1/notifications/{_Id}/{level}`
  },
  // POST per-feature email/push selection for a given level. Pro user always
  // passes `organization_Id`; the legacy endpoint shape is
  //   notification/v1/notificationlistconfig/{_Id}/{organization_Id}/{level}.
  POST_NOTI_LIST_CONFIG: {
    method: 'post',
    url: `${API_BASE_URL}notification/v1/notificationlistconfig/{_Id}/{organization_Id}/{level}`
  },
  // Duplicate an existing report template under a new name
  COPY_REPORT: {
    method: 'post',
    url: `${API_BASE_URL}organization/v1/copytemplate/{_Id}/{reportId}`
  },
  // Update the email recipients for a report template (Email Report action)
  EMAIL_REPORT: {
    method: 'put',
    url: `${API_BASE_URL}organization/v1/email/{_Id}/{reportId}`
  },
  // List the generated PDFs for a report template (View/Download action)
  VIEW_REPORT: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/reporturl/{_Id}/{reportId}`
  },
  // Download browsing-history report zip (classic list.js > downloadBrowsingHistory)
  DOWNLOAD_BROWSING_HISTORY_REPORT: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/downloadreport/{reportId}/{_Id}`
  },
  // Devices for one network (used by the Filter step's "Change" device picker)
  GET_NET_DEVICE_DETAILS_LIST: {
    method: 'get',
    url: `${API_BASE_URL}organization/v1/devicefilters/{_Id}`
  },
  // GET API to fetch the AP PoE Mode
  GET_AP_POE_MODE: {
    method: 'get',
    url: `${API_BASE_URL}device/v1/poeMode/{_Id}/{organization_Id}/{deviceId}`
  },
  // PUT API to update the AP PoE Mode
  PUT_AP_POE_MODE: {
    method: 'put',
    url: `${API_BASE_URL}device/v1/poeMode/{_Id}/{organization_Id}/{deviceId}`
  },
  // GET MUI migration / tour flags (muiWebSupport, tourCompleted)
  MUI_STATUS: {
    method: 'get',
    url: `${API_BASE_URL}public/v1/muiStatus/{_Id}`
  },
  // GET premium migration information
  PREMIUM_MIGRATION_INFO: {
    method: 'get',
    url: `${API_BASE_URL}user/v2/migrationInfo/{_Id}`
  },
  // PUT API to update tour status (tourCompleted)
  FIRST_LOGIN_TOUR_STATUS: {
    method: 'put',
    url: `${API_BASE_URL}public/v1/tourStatus/{_Id}`
  },
  UPDATE_MANAGEMENT_VLAN_WIRED: {
    method: 'put',
    url: `${API_BASE_URL}wired/v1/config/mgmtVlanConfig/{_Id}/{networkId}`
  },
  UPDATE_TRAFFIC_RULE_PRIORITY: {
    method: 'post',
    url: `${API_BASE_URL}device/v1/trafficRules/{deviceId}/{_Id}/priorityRule/{organization_Id}`
  },
  REBOOT_NOW: {
    method: 'post',
    url: `${API_BASE_URL}reboot/v1/reboot/{_Id}`
  },

  SET_REBOOT_SCHEDULE: {
    method: 'post',
    url: `${API_BASE_URL}scheduler/v1/{organization_Id}/setJobs/rebootPolicyJobs/{_Id}`
  },

  GET_REBOOT_SCHEDULES: {
    method: 'post',
    url: `${API_BASE_URL}reboot/v1/schedules/{userId}/{orgId}/{page}`
  },

  // Org Level : /reboot/v1/schedules/{userId}/{orgId}/{page}
  GET_REBOOT_SCHEDULES_ORG_LEVEL: {
    method: 'post',
    url: `${API_BASE_URL}reboot/v1/schedules/{userId}/{orgId}/{page}{searchText}`
  },

  // Location Level : /reboot/v1/schedules/{userId}/{orgId}/{networkId}/{page}
  GET_REBOOT_SCHEDULES_LOCATION_LEVEL: {
    method: 'post',
    url: `${API_BASE_URL}reboot/v1/schedules/{userId}/{orgId}/{networkId}/{page}{searchText}`
  },

  EDIT_REBOOT_SCHEDULE: {
    method: 'put',
    url: `${API_BASE_URL}scheduler/v1/{organization_Id}/{scheduleId}/updateJobs/rebootPolicyJobs/{_Id}`
  },

  /** Same as legacy `editSchedule` GET — load policy before editing (schedules hub / drawer). */
  GET_REBOOT_SCHEDULE_JOB: {
    method: 'get',
    url: `${API_BASE_URL}scheduler/v1/{organization_Id}/{scheduleId}/getJobs/rebootPolicyJobs/{_Id}`
  },
  GET_SCHEDULE_NETWORK_LIST: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/networks/{_Id}/{organization_Id}/true/{page}/networkFilter/true`
  },

  /**
   * Optimized endpoint for Schedule Reboot device list.
   * Uses batch Redis MGET for performance - returns same priStatus as Devices page.
   * Response: { devices: [{deviceId, deviceName, serialNo, deviceType, priStatus, remoteMgmtSt, networkId, networkName}], count, muiPaginationLimit }
   */
  GET_SCHEDULE_REBOOT_DEVICES: {
    method: 'get',
    url: `${API_BASE_URL}reboot/v1/scheduleDevices/{_Id}/{organization_Id}/{page}`
  },

  /** Devices that already appear on a reboot schedule (legacy `deviceInfoDetails`). GET path: org id + user `_Id` from cookie. */
  GET_REBOOT_SCHEDULED_DEVICE_INFO: {
    method: 'get',
    url: `${API_BASE_URL}reboot/v1/deviceInfo/{organization_Id}/{_Id}`
  },

  DELETE_REBOOT_SCHEDULE: {
    method: 'delete',
    url: `${API_BASE_URL}reboot/v1/{organization_Id}/{scheduleId}/{_Id}`
  },

  DELETE_REBOOT_SCHEDULE_MULTIPLE: {
    method: 'delete',
    url: `${API_BASE_URL}reboot/v1/deleteSchedulesBulk/{organization_Id}/{_Id}`
  },
  GET_FLOORS_LIST: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/{networkId}/{userId}/floors`
  },
  ADD_FLOOR: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/{networkId}/{_Id}/floor`
  },
  GET_FLOOR: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/{networkId}/{userId}/floor/{floorId}`
  },
  GET_UNASSIGNED_APS: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/{networkId}/{userId}/floor/unassignedAPs`
  },
  GET_UNASSIGNED_APS_PAGED: {
    method: 'get',
    url: `${API_BASE_URL}network/v1/{networkId}/{userId}/floor/unassignedAPs?offset={offset}&limit={limit}&search={search}`
  },
  DELETE_FLOOR: {
    method: 'delete',
    url: `${API_BASE_URL}network/v1/{networkId}/{userId}/floor/{floorId}`
  },
  UPDATE_FLOOR: {
    method: 'post',
    url: `${API_BASE_URL}network/v1/{networkId}/{userId}/updateFloor/{floorId}`
  },
  GET_HEATMAP_CONFIG: {
    method: 'get',
    url: `${API_BASE_URL}heatmap/v1/config/{userId}`
  },
  GET_HEATMAP_MODELS: {
    method: 'get',
    url: `${API_BASE_URL}heatmap/v1/models/{networkId}/{userId}`
  },
  // Switch Stacking display (PRJCBUGEN-63800) — read-only AppCom endpoints (/insightappcom/stacking/v1).
  GET_STACKS: {
    method: 'get',
    url: `${API_BASE_URL}stacking/v1/stacks/{networkId}/{userId}`
  },
  GET_STACKS_BY_ORG: {
    method: 'get',
    url: `${API_BASE_URL}stacking/v1/stacks/org/{orgId}/{userId}`
  },
  GET_STACKS_BY_ACCOUNT: {
    method: 'get',
    url: `${API_BASE_URL}stacking/v1/stacks/account/{userId}`
  },
  GET_STACK_DETAILS: {
    method: 'get',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/{userId}`
  },
  GET_STACKING_MIN_FIRMWARE: {
    method: 'get',
    url: `${API_BASE_URL}stacking/v1/minStackingFirmware/{userId}`
  },
  // Schema-driven configuration platform (PRJCBUGEN-64186): one generic endpoint serves the
  // self-describing schema bundle (descriptors + binding + dispatch + enumMaps) for a feature on a
  // platform, so a schema-aware UI renders, fills and dispatches device config without hardcoding
  // which schemas compose the feature. Query: { feature, platform, modelFamily?, version? }.
  GET_CONFIG_SCHEMA: {
    method: 'get',
    url: `${API_BASE_URL}config/v1/schema/{userId}`
  },
  GET_STACKABLE_DEVICES: {
    method: 'get',
    url: `${API_BASE_URL}stacking/v1/stackableDevices/{networkId}/{userId}`
  },
  GET_SWITCHES_BY_STACK_CLASS: {
    method: 'get',
    url: `${API_BASE_URL}stacking/v1/switches/{networkId}/{stackClass}/{userId}`
  },
  GET_MANAGEABLE_STACKS: {
    method: 'get',
    url: `${API_BASE_URL}stacking/v1/manageableStacks/{networkId}/{userId}`
  },
  GET_STACK_SUBSCRIPTIONS: {
    method: 'get',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/subscriptions/{userId}`
  },
  GET_STACK_ALERTS: {
    method: 'get',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/alerts/{userId}`
  },
  GET_STACK_CONNECTED_CLIENTS: {
    method: 'get',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/connectedClients/{userId}`
  },
  // Switch Stacking write operations (PRJCBUGEN-63801) — AppCom /insightappcom/stacking/v1.
  CREATE_STACK: {
    method: 'post',
    url: `${API_BASE_URL}stacking/v1/stack/{networkId}/{userId}`
  },
  // Schema-driven device configuration (PRJCBUGEN-64186): the portal posts the FINAL per-switch
  // SCHEMA_CLI messages to the DevCom BATCH endpoint (one entry per switch in a single call); DevCom
  // authenticates once, merges each into switchConfiguration, and passes them through to the switches.
  // Used to send the create-stack formation messages after CREATE_STACK stages the roster.
  SAVE_DEVICE_CONFIGURATION: {
    method: 'post',
    url: `${DEVCOM_BASE_URL}v1/deviceConfiguration/{networkId}/{userId}`
  },
  UPDATE_STACK: {
    method: 'put',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/{userId}`
  },
  RENAME_STACK: {
    method: 'put',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/name/{userId}`
  },
  MANAGE_STACK: {
    method: 'put',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/manage/{userId}`
  },
  DELETE_STACK: {
    method: 'delete',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/{userId}`,
    // 3 minutes, not the 60s default. INSIGHT_ONLY reuses deviceService.deleteDevice once per member,
    // and each pass clears Mongo, Redis and the ELK indices, so the wall-clock scales with unit count
    // (40-60s measured for 3 units in maint-dev). At the default a large stack would abort client-side
    // while the server finished, showing "failed" for a delete that succeeded.
    timeout: 180000
  },
  // PRJCBUGEN-65212 — restored, and no longer dead. The route was removed with the PRJCBUGEN-64186
  // schema-driven write cutover, which moved DEVICE CONFIG DISPATCH out of AppCom; that stays out (the
  // wizard sends its formation messages to DevCom itself). This records that a switch is JOINING, which
  // nothing else can — the units do not re-form until the user cables them, so no telemetry says so.
  ADD_STACK_MEMBER: {
    method: 'post',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/member/{userId}`
  },
  // PRJCBUGEN-65212 — cancel a staged addition. Unlike CANCEL_PENDING_STACK_MEMBER_REMOVAL this REVERTS
  // THE HARDWARE (stack-port mode/speed back to ethernet, priority restored) before discarding the
  // record, so it is as slow as a device write and answers an error without changing anything when the
  // switch is offline. Given the disband timeout for the same reason DELETE_STACK has one: it delivers
  // up to three commands to the switch plus one per affected member, each through the config transport.
  CANCEL_PENDING_STACK_ADDITION: {
    method: 'delete',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/member/{memberId}/pendingAddition/{userId}`,
    timeout: 180000
  },
  REMOVE_STACK_MEMBER: {
    method: 'delete',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/member/{memberId}/{userId}`
  },
  // PRJCBUGEN-64392 — undo a still-outstanding REMOVE_STACK_MEMBER request before the backend
  // reconciler finalizes it (e.g. the user changed their mind and never disconnected the unit).
  CANCEL_PENDING_STACK_MEMBER_REMOVAL: {
    method: 'delete',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/member/{memberId}/pendingRemoval/{userId}`
  },
  UPDATE_STACK_PRIORITIES: {
    method: 'put',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/priorities/{userId}`
  },
  REBOOT_STACK: {
    method: 'post',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/reboot/{userId}`
  },
  REBOOT_STACK_UNIT: {
    method: 'post',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/unit/{unitId}/reboot/{userId}`
  },
  FACTORY_RESET_STACK_UNIT: {
    method: 'post',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/unit/{unitId}/factory-reset/{userId}`
  },
  UPDATE_STACK_PORT_CONFIG: {
    method: 'put',
    url: `${API_BASE_URL}stacking/v1/stack/{stackId}/portConfig/{userId}`
  },
  // Switch troubleshooting API endpoints for stacking
  GET_SWITCH_SUMMARY_DATA_STACK: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/deviceInfo/{deviceId}/SW/dashboard/{_Id}`
  },
  TEST_SELECTED_PORTS_SWITCH_STACK: {
    method: 'post',
    url: `${API_BASE_URL}device/v2/config/{deviceId}/SW/cabletest/{_Id}/{orgId}`
  },
  GET_TEST_RESULT_SWITCH_STACK: {
    method: 'get',
    url: `${API_BASE_URL}device/v2/deviceInfo/{deviceId}/SW/cabletest/{_Id}`
  },
  // Hindsight (aidn-agent). Under /aidn/** because that service registers CORS for that prefix only.
  HINDSIGHT_TEMPLATES: {
    method: 'get',
    url: `${AIDN_BASE_URL}/aidn/v1/hindsight/templates`
  },
  HINDSIGHT_INVESTIGATE: {
    method: 'post',
    url: `${AIDN_BASE_URL}/aidn/v1/hindsight/investigate`
  },
  GET_MHS_CLIENT_PRIVACY: {
    method: 'get',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/{_Id}/{orgId}/{deviceId}/MHS/clientPrivacy`
  },
  PUT_MHS_CLIENT_PRIVACY: {
    method: 'put',
    url: `${API_BASE_URL.replace('insightappcom', 'insightmhs')}device/v1/updateconfig/{_Id}/{orgId}/{deviceId}/MHS/clientPrivacy`
  }
};

export { API_BASE_URL, GLOBAL_SEARCH_API_BASE_URL, AIDN_BASE_URL };
